(function () {

/*!
 * Font Awesome Free 6.0.0 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2022 Fonticons, Inc.
 */ function $08a5d3e60f51bb64$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}


function $bf68c0e6076612b9$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $bf68c0e6076612b9$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $bf68c0e6076612b9$var$ownKeys(Object(source), !0).forEach(function(key) {
            $bf68c0e6076612b9$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $bf68c0e6076612b9$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $bf68c0e6076612b9$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $bf68c0e6076612b9$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $bf68c0e6076612b9$var$_typeof(obj);
}
function $bf68c0e6076612b9$var$_wrapRegExp() {
    $bf68c0e6076612b9$var$_wrapRegExp = function _wrapRegExp(re, groups) {
        return new BabelRegExp(re, void 0, groups);
    };
    var _super = RegExp.prototype, _groups = new WeakMap();
    function BabelRegExp(re, flags, groups) {
        var _this = new RegExp(re, flags);
        return _groups.set(_this, groups || _groups.get(re)), $bf68c0e6076612b9$var$_setPrototypeOf(_this, BabelRegExp.prototype);
    }
    function buildGroups(result, re) {
        var g = _groups.get(re);
        return Object.keys(g).reduce(function(groups, name) {
            return groups[name] = result[g[name]], groups;
        }, Object.create(null));
    }
    return $bf68c0e6076612b9$var$_inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function(str) {
        var result = _super.exec.call(this, str);
        return result && (result.groups = buildGroups(result, this)), result;
    }, BabelRegExp.prototype[Symbol.replace] = function(str, substitution) {
        if ("string" == typeof substitution) {
            var groups = _groups.get(this);
            return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function(_, name) {
                return "$" + groups[name];
            }));
        }
        if ("function" == typeof substitution) {
            var _this = this;
            return _super[Symbol.replace].call(this, str, function() {
                var args = arguments;
                return "object" != (0, $08a5d3e60f51bb64$export$71511d61b312f219)(args[args.length - 1]) && (args = [].slice.call(args)).push(buildGroups(args, _this)), substitution.apply(this, args);
            });
        }
        return _super[Symbol.replace].call(this, str, substitution);
    }, $bf68c0e6076612b9$var$_wrapRegExp.apply(this, arguments);
}
function $bf68c0e6076612b9$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $bf68c0e6076612b9$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $bf68c0e6076612b9$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $bf68c0e6076612b9$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $bf68c0e6076612b9$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $bf68c0e6076612b9$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $bf68c0e6076612b9$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $bf68c0e6076612b9$var$_setPrototypeOf(subClass, superClass);
}
function $bf68c0e6076612b9$var$_setPrototypeOf(o, p) {
    $bf68c0e6076612b9$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $bf68c0e6076612b9$var$_setPrototypeOf(o, p);
}
function $bf68c0e6076612b9$var$_slicedToArray(arr, i) {
    return $bf68c0e6076612b9$var$_arrayWithHoles(arr) || $bf68c0e6076612b9$var$_iterableToArrayLimit(arr, i) || $bf68c0e6076612b9$var$_unsupportedIterableToArray(arr, i) || $bf68c0e6076612b9$var$_nonIterableRest();
}
function $bf68c0e6076612b9$var$_toConsumableArray(arr) {
    return $bf68c0e6076612b9$var$_arrayWithoutHoles(arr) || $bf68c0e6076612b9$var$_iterableToArray(arr) || $bf68c0e6076612b9$var$_unsupportedIterableToArray(arr) || $bf68c0e6076612b9$var$_nonIterableSpread();
}
function $bf68c0e6076612b9$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $bf68c0e6076612b9$var$_arrayLikeToArray(arr);
}
function $bf68c0e6076612b9$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $bf68c0e6076612b9$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $bf68c0e6076612b9$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $bf68c0e6076612b9$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $bf68c0e6076612b9$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $bf68c0e6076612b9$var$_arrayLikeToArray(o, minLen);
}
function $bf68c0e6076612b9$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $bf68c0e6076612b9$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $bf68c0e6076612b9$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $bf68c0e6076612b9$var$noop = function noop() {};
var $bf68c0e6076612b9$var$_WINDOW = {};
var $bf68c0e6076612b9$var$_DOCUMENT = {};
var $bf68c0e6076612b9$var$_MUTATION_OBSERVER = null;
var $bf68c0e6076612b9$var$_PERFORMANCE = {
    mark: $bf68c0e6076612b9$var$noop,
    measure: $bf68c0e6076612b9$var$noop
};
try {
    if (typeof window !== 'undefined') $bf68c0e6076612b9$var$_WINDOW = window;
    if (typeof document !== 'undefined') $bf68c0e6076612b9$var$_DOCUMENT = document;
    if (typeof MutationObserver !== 'undefined') $bf68c0e6076612b9$var$_MUTATION_OBSERVER = MutationObserver;
    if (typeof performance !== 'undefined') $bf68c0e6076612b9$var$_PERFORMANCE = performance;
} catch (e) {}
var $bf68c0e6076612b9$var$_ref = $bf68c0e6076612b9$var$_WINDOW.navigator || {}, $bf68c0e6076612b9$var$_ref$userAgent = $bf68c0e6076612b9$var$_ref.userAgent, $bf68c0e6076612b9$var$userAgent = $bf68c0e6076612b9$var$_ref$userAgent === void 0 ? '' : $bf68c0e6076612b9$var$_ref$userAgent;
var $bf68c0e6076612b9$var$WINDOW = $bf68c0e6076612b9$var$_WINDOW;
var $bf68c0e6076612b9$var$DOCUMENT = $bf68c0e6076612b9$var$_DOCUMENT;
var $bf68c0e6076612b9$var$MUTATION_OBSERVER = $bf68c0e6076612b9$var$_MUTATION_OBSERVER;
var $bf68c0e6076612b9$var$PERFORMANCE = $bf68c0e6076612b9$var$_PERFORMANCE;
var $bf68c0e6076612b9$var$IS_BROWSER = !!$bf68c0e6076612b9$var$WINDOW.document;
var $bf68c0e6076612b9$var$IS_DOM = !!$bf68c0e6076612b9$var$DOCUMENT.documentElement && !!$bf68c0e6076612b9$var$DOCUMENT.head && typeof $bf68c0e6076612b9$var$DOCUMENT.addEventListener === 'function' && typeof $bf68c0e6076612b9$var$DOCUMENT.createElement === 'function';
var $bf68c0e6076612b9$var$IS_IE = ~$bf68c0e6076612b9$var$userAgent.indexOf('MSIE') || ~$bf68c0e6076612b9$var$userAgent.indexOf('Trident/');
var $bf68c0e6076612b9$var$NAMESPACE_IDENTIFIER = '___FONT_AWESOME___';
var $bf68c0e6076612b9$var$UNITS_IN_GRID = 16;
var $bf68c0e6076612b9$var$DEFAULT_FAMILY_PREFIX = 'fa';
var $bf68c0e6076612b9$var$DEFAULT_REPLACEMENT_CLASS = 'svg-inline--fa';
var $bf68c0e6076612b9$var$DATA_FA_I2SVG = 'data-fa-i2svg';
var $bf68c0e6076612b9$var$DATA_FA_PSEUDO_ELEMENT = 'data-fa-pseudo-element';
var $bf68c0e6076612b9$var$DATA_FA_PSEUDO_ELEMENT_PENDING = 'data-fa-pseudo-element-pending';
var $bf68c0e6076612b9$var$DATA_PREFIX = 'data-prefix';
var $bf68c0e6076612b9$var$DATA_ICON = 'data-icon';
var $bf68c0e6076612b9$var$HTML_CLASS_I2SVG_BASE_CLASS = 'fontawesome-i2svg';
var $bf68c0e6076612b9$var$MUTATION_APPROACH_ASYNC = 'async';
var $bf68c0e6076612b9$var$TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS = [
    'HTML',
    'HEAD',
    'STYLE',
    'SCRIPT'
];
var $bf68c0e6076612b9$var$PRODUCTION = function() {
    try {
        return true;
    } catch (e) {
        return false;
    }
}();
var $bf68c0e6076612b9$var$PREFIX_TO_STYLE = {
    'fas': 'solid',
    'fa-solid': 'solid',
    'far': 'regular',
    'fa-regular': 'regular',
    'fal': 'light',
    'fa-light': 'light',
    'fat': 'thin',
    'fa-thin': 'thin',
    'fad': 'duotone',
    'fa-duotone': 'duotone',
    'fab': 'brands',
    'fa-brands': 'brands',
    'fak': 'kit',
    'fa-kit': 'kit',
    'fa': 'solid'
};
var $bf68c0e6076612b9$var$STYLE_TO_PREFIX = {
    'solid': 'fas',
    'regular': 'far',
    'light': 'fal',
    'thin': 'fat',
    'duotone': 'fad',
    'brands': 'fab',
    'kit': 'fak'
};
var $bf68c0e6076612b9$var$PREFIX_TO_LONG_STYLE = {
    'fab': 'fa-brands',
    'fad': 'fa-duotone',
    'fak': 'fa-kit',
    'fal': 'fa-light',
    'far': 'fa-regular',
    'fas': 'fa-solid',
    'fat': 'fa-thin'
};
var $bf68c0e6076612b9$var$LONG_STYLE_TO_PREFIX = {
    'fa-brands': 'fab',
    'fa-duotone': 'fad',
    'fa-kit': 'fak',
    'fa-light': 'fal',
    'fa-regular': 'far',
    'fa-solid': 'fas',
    'fa-thin': 'fat'
};
var $bf68c0e6076612b9$var$ICON_SELECTION_SYNTAX_PATTERN = /fa[srltdbk\-\ ]/; // eslint-disable-line no-useless-escape
var $bf68c0e6076612b9$var$LAYERS_TEXT_CLASSNAME = 'fa-layers-text';
var $bf68c0e6076612b9$var$FONT_FAMILY_PATTERN = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Kit)?.*/i; // TODO: do we need to handle font-weight for kit SVG pseudo-elements?
var $bf68c0e6076612b9$var$FONT_WEIGHT_TO_PREFIX = {
    '900': 'fas',
    '400': 'far',
    'normal': 'far',
    '300': 'fal',
    '100': 'fat'
};
var $bf68c0e6076612b9$var$oneToTen = [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
var $bf68c0e6076612b9$var$oneToTwenty = $bf68c0e6076612b9$var$oneToTen.concat([
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20
]);
var $bf68c0e6076612b9$var$ATTRIBUTES_WATCHED_FOR_MUTATION = [
    'class',
    'data-prefix',
    'data-icon',
    'data-fa-transform',
    'data-fa-mask'
];
var $bf68c0e6076612b9$var$DUOTONE_CLASSES = {
    GROUP: 'duotone-group',
    SWAP_OPACITY: 'swap-opacity',
    PRIMARY: 'primary',
    SECONDARY: 'secondary'
};
var $bf68c0e6076612b9$var$RESERVED_CLASSES = [].concat($bf68c0e6076612b9$var$_toConsumableArray(Object.keys($bf68c0e6076612b9$var$STYLE_TO_PREFIX)), [
    '2xs',
    'xs',
    'sm',
    'lg',
    'xl',
    '2xl',
    'beat',
    'border',
    'fade',
    'beat-fade',
    'bounce',
    'flip-both',
    'flip-horizontal',
    'flip-vertical',
    'flip',
    'fw',
    'inverse',
    'layers-counter',
    'layers-text',
    'layers',
    'li',
    'pull-left',
    'pull-right',
    'pulse',
    'rotate-180',
    'rotate-270',
    'rotate-90',
    'rotate-by',
    'shake',
    'spin-pulse',
    'spin-reverse',
    'spin',
    'stack-1x',
    'stack-2x',
    'stack',
    'ul',
    $bf68c0e6076612b9$var$DUOTONE_CLASSES.GROUP,
    $bf68c0e6076612b9$var$DUOTONE_CLASSES.SWAP_OPACITY,
    $bf68c0e6076612b9$var$DUOTONE_CLASSES.PRIMARY,
    $bf68c0e6076612b9$var$DUOTONE_CLASSES.SECONDARY
]).concat($bf68c0e6076612b9$var$oneToTen.map(function(n) {
    return "".concat(n, "x");
})).concat($bf68c0e6076612b9$var$oneToTwenty.map(function(n) {
    return "w-".concat(n);
}));
var $bf68c0e6076612b9$var$initial = $bf68c0e6076612b9$var$WINDOW.FontAwesomeConfig || {};
function $bf68c0e6076612b9$var$getAttrConfig(attr) {
    var element = $bf68c0e6076612b9$var$DOCUMENT.querySelector('script[' + attr + ']');
    if (element) return element.getAttribute(attr);
}
function $bf68c0e6076612b9$var$coerce(val) {
    // Getting an empty string will occur if the attribute is set on the HTML tag but without a value
    // We'll assume that this is an indication that it should be toggled to true
    // For example <script data-search-pseudo-elements src="..."></script>
    if (val === '') return true;
    if (val === 'false') return false;
    if (val === 'true') return true;
    return val;
}
if ($bf68c0e6076612b9$var$DOCUMENT && typeof $bf68c0e6076612b9$var$DOCUMENT.querySelector === 'function') {
    var $bf68c0e6076612b9$var$attrs = [
        [
            'data-family-prefix',
            'familyPrefix'
        ],
        [
            'data-style-default',
            'styleDefault'
        ],
        [
            'data-replacement-class',
            'replacementClass'
        ],
        [
            'data-auto-replace-svg',
            'autoReplaceSvg'
        ],
        [
            'data-auto-add-css',
            'autoAddCss'
        ],
        [
            'data-auto-a11y',
            'autoA11y'
        ],
        [
            'data-search-pseudo-elements',
            'searchPseudoElements'
        ],
        [
            'data-observe-mutations',
            'observeMutations'
        ],
        [
            'data-mutate-approach',
            'mutateApproach'
        ],
        [
            'data-keep-original-source',
            'keepOriginalSource'
        ],
        [
            'data-measure-performance',
            'measurePerformance'
        ],
        [
            'data-show-missing-icons',
            'showMissingIcons'
        ]
    ];
    $bf68c0e6076612b9$var$attrs.forEach(function(_ref) {
        var _ref2 = $bf68c0e6076612b9$var$_slicedToArray(_ref, 2), attr = _ref2[0], key = _ref2[1];
        var val = $bf68c0e6076612b9$var$coerce($bf68c0e6076612b9$var$getAttrConfig(attr));
        if (val !== undefined && val !== null) $bf68c0e6076612b9$var$initial[key] = val;
    });
}
var $bf68c0e6076612b9$var$_default = {
    familyPrefix: $bf68c0e6076612b9$var$DEFAULT_FAMILY_PREFIX,
    styleDefault: 'solid',
    replacementClass: $bf68c0e6076612b9$var$DEFAULT_REPLACEMENT_CLASS,
    autoReplaceSvg: true,
    autoAddCss: true,
    autoA11y: true,
    searchPseudoElements: false,
    observeMutations: true,
    mutateApproach: 'async',
    keepOriginalSource: true,
    measurePerformance: false,
    showMissingIcons: true
};
var $bf68c0e6076612b9$var$_config = $bf68c0e6076612b9$var$_objectSpread2($bf68c0e6076612b9$var$_objectSpread2({}, $bf68c0e6076612b9$var$_default), $bf68c0e6076612b9$var$initial);
if (!$bf68c0e6076612b9$var$_config.autoReplaceSvg) $bf68c0e6076612b9$var$_config.observeMutations = false;
var $bf68c0e6076612b9$var$config = {};
Object.keys($bf68c0e6076612b9$var$_config).forEach(function(key) {
    Object.defineProperty($bf68c0e6076612b9$var$config, key, {
        enumerable: true,
        set: function set(val) {
            $bf68c0e6076612b9$var$_config[key] = val;
            $bf68c0e6076612b9$var$_onChangeCb.forEach(function(cb) {
                return cb($bf68c0e6076612b9$var$config);
            });
        },
        get: function get() {
            return $bf68c0e6076612b9$var$_config[key];
        }
    });
});
$bf68c0e6076612b9$var$WINDOW.FontAwesomeConfig = $bf68c0e6076612b9$var$config;
var $bf68c0e6076612b9$var$_onChangeCb = [];
function $bf68c0e6076612b9$var$onChange(cb) {
    $bf68c0e6076612b9$var$_onChangeCb.push(cb);
    return function() {
        $bf68c0e6076612b9$var$_onChangeCb.splice($bf68c0e6076612b9$var$_onChangeCb.indexOf(cb), 1);
    };
}
var $bf68c0e6076612b9$var$d = $bf68c0e6076612b9$var$UNITS_IN_GRID;
var $bf68c0e6076612b9$var$meaninglessTransform = {
    size: 16,
    x: 0,
    y: 0,
    rotate: 0,
    flipX: false,
    flipY: false
};
function $bf68c0e6076612b9$var$insertCss(css) {
    if (!css || !$bf68c0e6076612b9$var$IS_DOM) return;
    var style = $bf68c0e6076612b9$var$DOCUMENT.createElement('style');
    style.setAttribute('type', 'text/css');
    style.innerHTML = css;
    var headChildren = $bf68c0e6076612b9$var$DOCUMENT.head.childNodes;
    var beforeChild = null;
    for(var i = headChildren.length - 1; i > -1; i--){
        var child = headChildren[i];
        var tagName = (child.tagName || '').toUpperCase();
        if ([
            'STYLE',
            'LINK'
        ].indexOf(tagName) > -1) beforeChild = child;
    }
    $bf68c0e6076612b9$var$DOCUMENT.head.insertBefore(style, beforeChild);
    return css;
}
var $bf68c0e6076612b9$var$idPool = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
function $bf68c0e6076612b9$var$nextUniqueId() {
    var size = 12;
    var id = '';
    while(size-- > 0)id += $bf68c0e6076612b9$var$idPool[Math.random() * 62 | 0];
    return id;
}
function $bf68c0e6076612b9$var$toArray(obj) {
    var array = [];
    for(var i = (obj || []).length >>> 0; i--;)array[i] = obj[i];
    return array;
}
function $bf68c0e6076612b9$var$classArray(node) {
    if (node.classList) return $bf68c0e6076612b9$var$toArray(node.classList);
    else return (node.getAttribute('class') || '').split(' ').filter(function(i) {
        return i;
    });
}
function $bf68c0e6076612b9$var$htmlEscape(str) {
    return "".concat(str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
function $bf68c0e6076612b9$var$joinAttributes(attributes) {
    return Object.keys(attributes || {}).reduce(function(acc, attributeName) {
        return acc + "".concat(attributeName, "=\"").concat($bf68c0e6076612b9$var$htmlEscape(attributes[attributeName]), "\" ");
    }, '').trim();
}
function $bf68c0e6076612b9$var$joinStyles(styles) {
    return Object.keys(styles || {}).reduce(function(acc, styleName) {
        return acc + "".concat(styleName, ": ").concat(styles[styleName].trim(), ";");
    }, '');
}
function $bf68c0e6076612b9$var$transformIsMeaningful(transform) {
    return transform.size !== $bf68c0e6076612b9$var$meaninglessTransform.size || transform.x !== $bf68c0e6076612b9$var$meaninglessTransform.x || transform.y !== $bf68c0e6076612b9$var$meaninglessTransform.y || transform.rotate !== $bf68c0e6076612b9$var$meaninglessTransform.rotate || transform.flipX || transform.flipY;
}
function $bf68c0e6076612b9$var$transformForSvg(_ref) {
    var transform = _ref.transform, containerWidth = _ref.containerWidth, iconWidth = _ref.iconWidth;
    var outer = {
        transform: "translate(".concat(containerWidth / 2, " 256)")
    };
    var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
    var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
    var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
    var inner = {
        transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
    };
    var path = {
        transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
    };
    return {
        outer: outer,
        inner: inner,
        path: path
    };
}
function $bf68c0e6076612b9$var$transformForCss(_ref2) {
    var transform = _ref2.transform, _ref2$width = _ref2.width, width = _ref2$width === void 0 ? $bf68c0e6076612b9$var$UNITS_IN_GRID : _ref2$width, _ref2$height = _ref2.height, height = _ref2$height === void 0 ? $bf68c0e6076612b9$var$UNITS_IN_GRID : _ref2$height, _ref2$startCentered = _ref2.startCentered, startCentered = _ref2$startCentered === void 0 ? false : _ref2$startCentered;
    var val = '';
    if (startCentered && $bf68c0e6076612b9$var$IS_IE) val += "translate(".concat(transform.x / $bf68c0e6076612b9$var$d - width / 2, "em, ").concat(transform.y / $bf68c0e6076612b9$var$d - height / 2, "em) ");
    else if (startCentered) val += "translate(calc(-50% + ".concat(transform.x / $bf68c0e6076612b9$var$d, "em), calc(-50% + ").concat(transform.y / $bf68c0e6076612b9$var$d, "em)) ");
    else val += "translate(".concat(transform.x / $bf68c0e6076612b9$var$d, "em, ").concat(transform.y / $bf68c0e6076612b9$var$d, "em) ");
    val += "scale(".concat(transform.size / $bf68c0e6076612b9$var$d * (transform.flipX ? -1 : 1), ", ").concat(transform.size / $bf68c0e6076612b9$var$d * (transform.flipY ? -1 : 1), ") ");
    val += "rotate(".concat(transform.rotate, "deg) ");
    return val;
}
var $bf68c0e6076612b9$var$baseStyles = ":root, :host {\n  --fa-font-solid: normal 900 1em/1 \"Font Awesome 6 Solid\";\n  --fa-font-regular: normal 400 1em/1 \"Font Awesome 6 Regular\";\n  --fa-font-light: normal 300 1em/1 \"Font Awesome 6 Light\";\n  --fa-font-thin: normal 100 1em/1 \"Font Awesome 6 Thin\";\n  --fa-font-duotone: normal 900 1em/1 \"Font Awesome 6 Duotone\";\n  --fa-font-brands: normal 400 1em/1 \"Font Awesome 6 Brands\";\n}\n\nsvg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {\n  overflow: visible;\n  box-sizing: content-box;\n}\n\n.svg-inline--fa {\n  display: var(--fa-display, inline-block);\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-2xs {\n  vertical-align: 0.1em;\n}\n.svg-inline--fa.fa-xs {\n  vertical-align: 0em;\n}\n.svg-inline--fa.fa-sm {\n  vertical-align: -0.0714285705em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.2em;\n}\n.svg-inline--fa.fa-xl {\n  vertical-align: -0.25em;\n}\n.svg-inline--fa.fa-2xl {\n  vertical-align: -0.3125em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-li {\n  width: var(--fa-li-width, 2em);\n  top: 0.25em;\n}\n.svg-inline--fa.fa-fw {\n  width: var(--fa-fw-width, 1.25em);\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: var(--fa-counter-background-color, #ff253a);\n  border-radius: var(--fa-counter-border-radius, 1em);\n  box-sizing: border-box;\n  color: var(--fa-inverse, #fff);\n  line-height: var(--fa-counter-line-height, 1);\n  max-width: var(--fa-counter-max-width, 5em);\n  min-width: var(--fa-counter-min-width, 1.5em);\n  overflow: hidden;\n  padding: var(--fa-counter-padding, 0.25em 0.5em);\n  right: var(--fa-right, 0);\n  text-overflow: ellipsis;\n  top: var(--fa-top, 0);\n  -webkit-transform: scale(var(--fa-counter-scale, 0.25));\n          transform: scale(var(--fa-counter-scale, 0.25));\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: var(--fa-bottom, 0);\n  right: var(--fa-right, 0);\n  top: auto;\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: bottom right;\n          transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: var(--fa-bottom, 0);\n  left: var(--fa-left, 0);\n  right: auto;\n  top: auto;\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: bottom left;\n          transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  top: var(--fa-top, 0);\n  right: var(--fa-right, 0);\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: var(--fa-left, 0);\n  right: auto;\n  top: var(--fa-top, 0);\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: top left;\n          transform-origin: top left;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-2xs {\n  font-size: 0.625em;\n  line-height: 0.1em;\n  vertical-align: 0.225em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n  line-height: 0.0833333337em;\n  vertical-align: 0.125em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n  line-height: 0.0714285718em;\n  vertical-align: 0.0535714295em;\n}\n\n.fa-lg {\n  font-size: 1.25em;\n  line-height: 0.05em;\n  vertical-align: -0.075em;\n}\n\n.fa-xl {\n  font-size: 1.5em;\n  line-height: 0.0416666682em;\n  vertical-align: -0.125em;\n}\n\n.fa-2xl {\n  font-size: 2em;\n  line-height: 0.03125em;\n  vertical-align: -0.1875em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: var(--fa-li-margin, 2.5em);\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: calc(var(--fa-li-width, 2em) * -1);\n  position: absolute;\n  text-align: center;\n  width: var(--fa-li-width, 2em);\n  line-height: inherit;\n}\n\n.fa-border {\n  border-color: var(--fa-border-color, #eee);\n  border-radius: var(--fa-border-radius, 0.1em);\n  border-style: var(--fa-border-style, solid);\n  border-width: var(--fa-border-width, 0.08em);\n  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);\n}\n\n.fa-pull-left {\n  float: left;\n  margin-right: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-pull-right {\n  float: right;\n  margin-left: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-beat {\n  -webkit-animation-name: fa-beat;\n          animation-name: fa-beat;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);\n          animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-bounce {\n  -webkit-animation-name: fa-bounce;\n          animation-name: fa-bounce;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n}\n\n.fa-fade {\n  -webkit-animation-name: fa-fade;\n          animation-name: fa-fade;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-beat-fade {\n  -webkit-animation-name: fa-beat-fade;\n          animation-name: fa-beat-fade;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-flip {\n  -webkit-animation-name: fa-flip;\n          animation-name: fa-flip;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);\n          animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-shake {\n  -webkit-animation-name: fa-shake;\n          animation-name: fa-shake;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, linear);\n          animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin {\n  -webkit-animation-name: fa-spin;\n          animation-name: fa-spin;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 2s);\n          animation-duration: var(--fa-animation-duration, 2s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, linear);\n          animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin-reverse {\n  --fa-animation-direction: reverse;\n}\n\n.fa-pulse,\n.fa-spin-pulse {\n  -webkit-animation-name: fa-spin;\n          animation-name: fa-spin;\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, steps(8));\n          animation-timing-function: var(--fa-animation-timing, steps(8));\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .fa-beat,\n.fa-bounce,\n.fa-fade,\n.fa-beat-fade,\n.fa-flip,\n.fa-pulse,\n.fa-shake,\n.fa-spin,\n.fa-spin-pulse {\n    -webkit-animation-delay: -1ms;\n            animation-delay: -1ms;\n    -webkit-animation-duration: 1ms;\n            animation-duration: 1ms;\n    -webkit-animation-iteration-count: 1;\n            animation-iteration-count: 1;\n    transition-delay: 0s;\n    transition-duration: 0s;\n  }\n}\n@-webkit-keyframes fa-beat {\n  0%, 90% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  45% {\n    -webkit-transform: scale(var(--fa-beat-scale, 1.25));\n            transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@keyframes fa-beat {\n  0%, 90% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  45% {\n    -webkit-transform: scale(var(--fa-beat-scale, 1.25));\n            transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@-webkit-keyframes fa-bounce {\n  0% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n}\n@keyframes fa-bounce {\n  0% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n}\n@-webkit-keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@-webkit-keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));\n            transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));\n            transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@-webkit-keyframes fa-flip {\n  50% {\n    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@keyframes fa-flip {\n  50% {\n    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@-webkit-keyframes fa-shake {\n  0% {\n    -webkit-transform: rotate(-15deg);\n            transform: rotate(-15deg);\n  }\n  4% {\n    -webkit-transform: rotate(15deg);\n            transform: rotate(15deg);\n  }\n  8%, 24% {\n    -webkit-transform: rotate(-18deg);\n            transform: rotate(-18deg);\n  }\n  12%, 28% {\n    -webkit-transform: rotate(18deg);\n            transform: rotate(18deg);\n  }\n  16% {\n    -webkit-transform: rotate(-22deg);\n            transform: rotate(-22deg);\n  }\n  20% {\n    -webkit-transform: rotate(22deg);\n            transform: rotate(22deg);\n  }\n  32% {\n    -webkit-transform: rotate(-12deg);\n            transform: rotate(-12deg);\n  }\n  36% {\n    -webkit-transform: rotate(12deg);\n            transform: rotate(12deg);\n  }\n  40%, 100% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n}\n@keyframes fa-shake {\n  0% {\n    -webkit-transform: rotate(-15deg);\n            transform: rotate(-15deg);\n  }\n  4% {\n    -webkit-transform: rotate(15deg);\n            transform: rotate(15deg);\n  }\n  8%, 24% {\n    -webkit-transform: rotate(-18deg);\n            transform: rotate(-18deg);\n  }\n  12%, 28% {\n    -webkit-transform: rotate(18deg);\n            transform: rotate(18deg);\n  }\n  16% {\n    -webkit-transform: rotate(-22deg);\n            transform: rotate(-22deg);\n  }\n  20% {\n    -webkit-transform: rotate(22deg);\n            transform: rotate(22deg);\n  }\n  32% {\n    -webkit-transform: rotate(-12deg);\n            transform: rotate(-12deg);\n  }\n  36% {\n    -webkit-transform: rotate(12deg);\n            transform: rotate(12deg);\n  }\n  40%, 100% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n}\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1);\n}\n\n.fa-flip-both,\n.fa-flip-horizontal.fa-flip-vertical {\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1);\n}\n\n.fa-rotate-by {\n  -webkit-transform: rotate(var(--fa-rotate-angle, none));\n          transform: rotate(var(--fa-rotate-angle, none));\n}\n\n.fa-stack {\n  display: inline-block;\n  vertical-align: middle;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: var(--fa-stack-z-index, auto);\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}\n\n.sr-only,\n.fa-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.sr-only-focusable:not(:focus),\n.fa-sr-only-focusable:not(:focus) {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}\n\n.fad.fa-inverse,\n.fa-duotone.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}";
function $bf68c0e6076612b9$var$css() {
    var dfp = $bf68c0e6076612b9$var$DEFAULT_FAMILY_PREFIX;
    var drc = $bf68c0e6076612b9$var$DEFAULT_REPLACEMENT_CLASS;
    var fp = $bf68c0e6076612b9$var$config.familyPrefix;
    var rc = $bf68c0e6076612b9$var$config.replacementClass;
    var s = $bf68c0e6076612b9$var$baseStyles;
    if (fp !== dfp || rc !== drc) {
        var dPatt = new RegExp("\\.".concat(dfp, "\\-"), 'g');
        var customPropPatt = new RegExp("\\--".concat(dfp, "\\-"), 'g');
        var rPatt = new RegExp("\\.".concat(drc), 'g');
        s = s.replace(dPatt, ".".concat(fp, "-")).replace(customPropPatt, "--".concat(fp, "-")).replace(rPatt, ".".concat(rc));
    }
    return s;
}
var $bf68c0e6076612b9$var$_cssInserted = false;
function $bf68c0e6076612b9$var$ensureCss() {
    if ($bf68c0e6076612b9$var$config.autoAddCss && !$bf68c0e6076612b9$var$_cssInserted) {
        $bf68c0e6076612b9$var$insertCss($bf68c0e6076612b9$var$css());
        $bf68c0e6076612b9$var$_cssInserted = true;
    }
}
var $bf68c0e6076612b9$var$InjectCSS = {
    mixout: function mixout() {
        return {
            dom: {
                css: $bf68c0e6076612b9$var$css,
                insertCss: $bf68c0e6076612b9$var$ensureCss
            }
        };
    },
    hooks: function hooks() {
        return {
            beforeDOMElementCreation: function beforeDOMElementCreation() {
                $bf68c0e6076612b9$var$ensureCss();
            },
            beforeI2svg: function beforeI2svg() {
                $bf68c0e6076612b9$var$ensureCss();
            }
        };
    }
};
var $bf68c0e6076612b9$var$w = $bf68c0e6076612b9$var$WINDOW || {};
if (!$bf68c0e6076612b9$var$w[$bf68c0e6076612b9$var$NAMESPACE_IDENTIFIER]) $bf68c0e6076612b9$var$w[$bf68c0e6076612b9$var$NAMESPACE_IDENTIFIER] = {};
if (!$bf68c0e6076612b9$var$w[$bf68c0e6076612b9$var$NAMESPACE_IDENTIFIER].styles) $bf68c0e6076612b9$var$w[$bf68c0e6076612b9$var$NAMESPACE_IDENTIFIER].styles = {};
if (!$bf68c0e6076612b9$var$w[$bf68c0e6076612b9$var$NAMESPACE_IDENTIFIER].hooks) $bf68c0e6076612b9$var$w[$bf68c0e6076612b9$var$NAMESPACE_IDENTIFIER].hooks = {};
if (!$bf68c0e6076612b9$var$w[$bf68c0e6076612b9$var$NAMESPACE_IDENTIFIER].shims) $bf68c0e6076612b9$var$w[$bf68c0e6076612b9$var$NAMESPACE_IDENTIFIER].shims = [];
var $bf68c0e6076612b9$var$namespace = $bf68c0e6076612b9$var$w[$bf68c0e6076612b9$var$NAMESPACE_IDENTIFIER];
var $bf68c0e6076612b9$var$functions = [];
var $bf68c0e6076612b9$var$listener = function listener() {
    $bf68c0e6076612b9$var$DOCUMENT.removeEventListener('DOMContentLoaded', listener);
    $bf68c0e6076612b9$var$loaded = 1;
    $bf68c0e6076612b9$var$functions.map(function(fn) {
        return fn();
    });
};
var $bf68c0e6076612b9$var$loaded = false;
if ($bf68c0e6076612b9$var$IS_DOM) {
    $bf68c0e6076612b9$var$loaded = ($bf68c0e6076612b9$var$DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test($bf68c0e6076612b9$var$DOCUMENT.readyState);
    if (!$bf68c0e6076612b9$var$loaded) $bf68c0e6076612b9$var$DOCUMENT.addEventListener('DOMContentLoaded', $bf68c0e6076612b9$var$listener);
}
function $bf68c0e6076612b9$var$domready(fn) {
    if (!$bf68c0e6076612b9$var$IS_DOM) return;
    $bf68c0e6076612b9$var$loaded ? setTimeout(fn, 0) : $bf68c0e6076612b9$var$functions.push(fn);
}
function $bf68c0e6076612b9$var$toHtml(abstractNodes) {
    var tag = abstractNodes.tag, _abstractNodes$attrib = abstractNodes.attributes, attributes = _abstractNodes$attrib === void 0 ? {} : _abstractNodes$attrib, _abstractNodes$childr = abstractNodes.children, children = _abstractNodes$childr === void 0 ? [] : _abstractNodes$childr;
    if (typeof abstractNodes === 'string') return $bf68c0e6076612b9$var$htmlEscape(abstractNodes);
    else return "<".concat(tag, " ").concat($bf68c0e6076612b9$var$joinAttributes(attributes), ">").concat(children.map($bf68c0e6076612b9$var$toHtml).join(''), "</").concat(tag, ">");
}
function $bf68c0e6076612b9$var$iconFromMapping(mapping, prefix, iconName) {
    if (mapping && mapping[prefix] && mapping[prefix][iconName]) return {
        prefix: prefix,
        iconName: iconName,
        icon: mapping[prefix][iconName]
    };
}
/**
 * Internal helper to bind a function known to have 4 arguments
 * to a given context.
 */ var $bf68c0e6076612b9$var$bindInternal4 = function bindInternal4(func, thisContext) {
    return function(a, b, c, d) {
        return func.call(thisContext, a, b, c, d);
    };
};
/**
 * # Reduce
 *
 * A fast object `.reduce()` implementation.
 *
 * @param  {Object}   subject      The object to reduce over.
 * @param  {Function} fn           The reducer function.
 * @param  {mixed}    initialValue The initial value for the reducer, defaults to subject[0].
 * @param  {Object}   thisContext  The context for the reducer.
 * @return {mixed}                 The final result.
 */ var $bf68c0e6076612b9$var$reduce = function fastReduceObject(subject, fn, initialValue, thisContext) {
    var keys = Object.keys(subject), length = keys.length, iterator = thisContext !== undefined ? $bf68c0e6076612b9$var$bindInternal4(fn, thisContext) : fn, i, key, result;
    if (initialValue === undefined) {
        i = 1;
        result = subject[keys[0]];
    } else {
        i = 0;
        result = initialValue;
    }
    for(; i < length; i++){
        key = keys[i];
        result = iterator(result, subject[key], key, subject);
    }
    return result;
};
/**
 * ucs2decode() and codePointAt() are both works of Mathias Bynens and licensed under MIT
 *
 * Copyright Mathias Bynens <https://mathiasbynens.be/>

 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:

 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ function $bf68c0e6076612b9$var$ucs2decode(string) {
    var output = [];
    var counter = 0;
    var length = string.length;
    while(counter < length){
        var value = string.charCodeAt(counter++);
        if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
            var extra = string.charCodeAt(counter++);
            if ((extra & 0xFC00) == 0xDC00) // eslint-disable-line eqeqeq
            output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
            else {
                output.push(value);
                counter--;
            }
        } else output.push(value);
    }
    return output;
}
function $bf68c0e6076612b9$var$toHex(unicode) {
    var decoded = $bf68c0e6076612b9$var$ucs2decode(unicode);
    return decoded.length === 1 ? decoded[0].toString(16) : null;
}
function $bf68c0e6076612b9$var$codePointAt(string, index) {
    var size = string.length;
    var first = string.charCodeAt(index);
    var second;
    if (first >= 0xD800 && first <= 0xDBFF && size > index + 1) {
        second = string.charCodeAt(index + 1);
        if (second >= 0xDC00 && second <= 0xDFFF) return (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
    }
    return first;
}
function $bf68c0e6076612b9$var$normalizeIcons(icons) {
    return Object.keys(icons).reduce(function(acc, iconName) {
        var icon = icons[iconName];
        var expanded = !!icon.icon;
        if (expanded) acc[icon.iconName] = icon.icon;
        else acc[iconName] = icon;
        return acc;
    }, {});
}
function $bf68c0e6076612b9$var$defineIcons(prefix, icons) {
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var _params$skipHooks = params.skipHooks, skipHooks = _params$skipHooks === void 0 ? false : _params$skipHooks;
    var normalized = $bf68c0e6076612b9$var$normalizeIcons(icons);
    if (typeof $bf68c0e6076612b9$var$namespace.hooks.addPack === 'function' && !skipHooks) $bf68c0e6076612b9$var$namespace.hooks.addPack(prefix, $bf68c0e6076612b9$var$normalizeIcons(icons));
    else $bf68c0e6076612b9$var$namespace.styles[prefix] = $bf68c0e6076612b9$var$_objectSpread2($bf68c0e6076612b9$var$_objectSpread2({}, $bf68c0e6076612b9$var$namespace.styles[prefix] || {}), normalized);
    /**
   * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
   * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
   * for `fas` so we'll ease the upgrade process for our users by automatically defining
   * this as well.
   */ if (prefix === 'fas') $bf68c0e6076612b9$var$defineIcons('fa', icons);
}
var $bf68c0e6076612b9$var$duotonePathRe = [
    /*#__PURE__*/ $bf68c0e6076612b9$var$_wrapRegExp(/path d="((?:(?!")[\s\S])+)".*path d="((?:(?!")[\s\S])+)"/, {
        d1: 1,
        d2: 2
    }),
    /*#__PURE__*/ $bf68c0e6076612b9$var$_wrapRegExp(/path class="((?:(?!")[\s\S])+)".*d="((?:(?!")[\s\S])+)".*path class="((?:(?!")[\s\S])+)".*d="((?:(?!")[\s\S])+)"/, {
        cls1: 1,
        d1: 2,
        cls2: 3,
        d2: 4
    }),
    /*#__PURE__*/ $bf68c0e6076612b9$var$_wrapRegExp(/path class="((?:(?!")[\s\S])+)".*d="((?:(?!")[\s\S])+)"/, {
        cls1: 1,
        d1: 2
    })
];
var $bf68c0e6076612b9$var$styles = $bf68c0e6076612b9$var$namespace.styles, $bf68c0e6076612b9$var$shims = $bf68c0e6076612b9$var$namespace.shims;
var $bf68c0e6076612b9$var$LONG_STYLE = Object.values($bf68c0e6076612b9$var$PREFIX_TO_LONG_STYLE);
var $bf68c0e6076612b9$var$_defaultUsablePrefix = null;
var $bf68c0e6076612b9$var$_byUnicode = {};
var $bf68c0e6076612b9$var$_byLigature = {};
var $bf68c0e6076612b9$var$_byOldName = {};
var $bf68c0e6076612b9$var$_byOldUnicode = {};
var $bf68c0e6076612b9$var$_byAlias = {};
var $bf68c0e6076612b9$var$PREFIXES = Object.keys($bf68c0e6076612b9$var$PREFIX_TO_STYLE);
function $bf68c0e6076612b9$var$isReserved(name) {
    return ~$bf68c0e6076612b9$var$RESERVED_CLASSES.indexOf(name);
}
function $bf68c0e6076612b9$var$getIconName(familyPrefix, cls) {
    var parts = cls.split('-');
    var prefix = parts[0];
    var iconName = parts.slice(1).join('-');
    if (prefix === familyPrefix && iconName !== '' && !$bf68c0e6076612b9$var$isReserved(iconName)) return iconName;
    else return null;
}
var $bf68c0e6076612b9$var$build = function build() {
    var lookup = function lookup(reducer) {
        return $bf68c0e6076612b9$var$reduce($bf68c0e6076612b9$var$styles, function(o, style, prefix) {
            o[prefix] = $bf68c0e6076612b9$var$reduce(style, reducer, {});
            return o;
        }, {});
    };
    $bf68c0e6076612b9$var$_byUnicode = lookup(function(acc, icon, iconName) {
        if (icon[3]) acc[icon[3]] = iconName;
        if (icon[2]) {
            var aliases = icon[2].filter(function(a) {
                return typeof a === 'number';
            });
            aliases.forEach(function(alias) {
                acc[alias.toString(16)] = iconName;
            });
        }
        return acc;
    });
    $bf68c0e6076612b9$var$_byLigature = lookup(function(acc, icon, iconName) {
        acc[iconName] = iconName;
        if (icon[2]) {
            var aliases = icon[2].filter(function(a) {
                return typeof a === 'string';
            });
            aliases.forEach(function(alias) {
                acc[alias] = iconName;
            });
        }
        return acc;
    });
    $bf68c0e6076612b9$var$_byAlias = lookup(function(acc, icon, iconName) {
        var aliases = icon[2];
        acc[iconName] = iconName;
        aliases.forEach(function(alias) {
            acc[alias] = iconName;
        });
        return acc;
    }); // If we have a Kit, we can't determine if regular is available since we
    // could be auto-fetching it. We'll have to assume that it is available.
    var hasRegular = 'far' in $bf68c0e6076612b9$var$styles || $bf68c0e6076612b9$var$config.autoFetchSvg;
    var shimLookups = $bf68c0e6076612b9$var$reduce($bf68c0e6076612b9$var$shims, function(acc, shim) {
        var maybeNameMaybeUnicode = shim[0];
        var prefix = shim[1];
        var iconName = shim[2];
        if (prefix === 'far' && !hasRegular) prefix = 'fas';
        if (typeof maybeNameMaybeUnicode === 'string') acc.names[maybeNameMaybeUnicode] = {
            prefix: prefix,
            iconName: iconName
        };
        if (typeof maybeNameMaybeUnicode === 'number') acc.unicodes[maybeNameMaybeUnicode.toString(16)] = {
            prefix: prefix,
            iconName: iconName
        };
        return acc;
    }, {
        names: {},
        unicodes: {}
    });
    $bf68c0e6076612b9$var$_byOldName = shimLookups.names;
    $bf68c0e6076612b9$var$_byOldUnicode = shimLookups.unicodes;
    $bf68c0e6076612b9$var$_defaultUsablePrefix = $bf68c0e6076612b9$var$getCanonicalPrefix($bf68c0e6076612b9$var$config.styleDefault);
};
$bf68c0e6076612b9$var$onChange(function(c) {
    $bf68c0e6076612b9$var$_defaultUsablePrefix = $bf68c0e6076612b9$var$getCanonicalPrefix(c.styleDefault);
});
$bf68c0e6076612b9$var$build();
function $bf68c0e6076612b9$var$byUnicode(prefix, unicode) {
    return ($bf68c0e6076612b9$var$_byUnicode[prefix] || {})[unicode];
}
function $bf68c0e6076612b9$var$byLigature(prefix, ligature) {
    return ($bf68c0e6076612b9$var$_byLigature[prefix] || {})[ligature];
}
function $bf68c0e6076612b9$var$byAlias(prefix, alias) {
    return ($bf68c0e6076612b9$var$_byAlias[prefix] || {})[alias];
}
function $bf68c0e6076612b9$var$byOldName(name) {
    return $bf68c0e6076612b9$var$_byOldName[name] || {
        prefix: null,
        iconName: null
    };
}
function $bf68c0e6076612b9$var$byOldUnicode(unicode) {
    var oldUnicode = $bf68c0e6076612b9$var$_byOldUnicode[unicode];
    var newUnicode = $bf68c0e6076612b9$var$byUnicode('fas', unicode);
    return oldUnicode || (newUnicode ? {
        prefix: 'fas',
        iconName: newUnicode
    } : null) || {
        prefix: null,
        iconName: null
    };
}
function $bf68c0e6076612b9$var$getDefaultUsablePrefix() {
    return $bf68c0e6076612b9$var$_defaultUsablePrefix;
}
var $bf68c0e6076612b9$var$emptyCanonicalIcon = function emptyCanonicalIcon() {
    return {
        prefix: null,
        iconName: null,
        rest: []
    };
};
function $bf68c0e6076612b9$var$getCanonicalPrefix(styleOrPrefix) {
    var style = $bf68c0e6076612b9$var$PREFIX_TO_STYLE[styleOrPrefix];
    var prefix = $bf68c0e6076612b9$var$STYLE_TO_PREFIX[styleOrPrefix] || $bf68c0e6076612b9$var$STYLE_TO_PREFIX[style];
    var defined = styleOrPrefix in $bf68c0e6076612b9$var$namespace.styles ? styleOrPrefix : null;
    return prefix || defined || null;
}
function $bf68c0e6076612b9$var$getCanonicalIcon(values) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$skipLookups = params.skipLookups, skipLookups = _params$skipLookups === void 0 ? false : _params$skipLookups;
    var givenPrefix = null;
    var canonical = values.reduce(function(acc, cls) {
        var iconName = $bf68c0e6076612b9$var$getIconName($bf68c0e6076612b9$var$config.familyPrefix, cls);
        if ($bf68c0e6076612b9$var$styles[cls]) {
            cls = $bf68c0e6076612b9$var$LONG_STYLE.includes(cls) ? $bf68c0e6076612b9$var$LONG_STYLE_TO_PREFIX[cls] : cls;
            givenPrefix = cls;
            acc.prefix = cls;
        } else if ($bf68c0e6076612b9$var$PREFIXES.indexOf(cls) > -1) {
            givenPrefix = cls;
            acc.prefix = $bf68c0e6076612b9$var$getCanonicalPrefix(cls);
        } else if (iconName) acc.iconName = iconName;
        else if (cls !== $bf68c0e6076612b9$var$config.replacementClass) acc.rest.push(cls);
        if (!skipLookups && acc.prefix && acc.iconName) {
            var shim = givenPrefix === 'fa' ? $bf68c0e6076612b9$var$byOldName(acc.iconName) : {};
            var aliasIconName = $bf68c0e6076612b9$var$byAlias(acc.prefix, acc.iconName);
            if (shim.prefix) givenPrefix = null;
            acc.iconName = shim.iconName || aliasIconName || acc.iconName;
            acc.prefix = shim.prefix || acc.prefix;
            if (acc.prefix === 'far' && !$bf68c0e6076612b9$var$styles['far'] && $bf68c0e6076612b9$var$styles['fas'] && !$bf68c0e6076612b9$var$config.autoFetchSvg) // Allow a fallback from the regular style to solid if regular is not available
            // but only if we aren't auto-fetching SVGs
            acc.prefix = 'fas';
        }
        return acc;
    }, $bf68c0e6076612b9$var$emptyCanonicalIcon());
    if (canonical.prefix === 'fa' || givenPrefix === 'fa') // The fa prefix is not canonical. So if it has made it through until this point
    // we will shift it to the correct prefix.
    canonical.prefix = $bf68c0e6076612b9$var$getDefaultUsablePrefix() || 'fas';
    return canonical;
}
var $bf68c0e6076612b9$var$Library = /*#__PURE__*/ function() {
    function Library() {
        $bf68c0e6076612b9$var$_classCallCheck(this, Library);
        this.definitions = {};
    }
    $bf68c0e6076612b9$var$_createClass(Library, [
        {
            key: "add",
            value: function add() {
                var _this = this;
                for(var _len = arguments.length, definitions = new Array(_len), _key = 0; _key < _len; _key++)definitions[_key] = arguments[_key];
                var additions = definitions.reduce(this._pullDefinitions, {});
                Object.keys(additions).forEach(function(key) {
                    _this.definitions[key] = $bf68c0e6076612b9$var$_objectSpread2($bf68c0e6076612b9$var$_objectSpread2({}, _this.definitions[key] || {}), additions[key]);
                    $bf68c0e6076612b9$var$defineIcons(key, additions[key]);
                    var longPrefix = $bf68c0e6076612b9$var$PREFIX_TO_LONG_STYLE[key];
                    if (longPrefix) $bf68c0e6076612b9$var$defineIcons(longPrefix, additions[key]);
                    $bf68c0e6076612b9$var$build();
                });
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.definitions = {};
            }
        },
        {
            key: "_pullDefinitions",
            value: function _pullDefinitions(additions, definition) {
                var normalized = definition.prefix && definition.iconName && definition.icon ? {
                    0: definition
                } : definition;
                Object.keys(normalized).map(function(key) {
                    var _normalized$key = normalized[key], prefix = _normalized$key.prefix, iconName = _normalized$key.iconName, icon = _normalized$key.icon;
                    var aliases = icon[2];
                    if (!additions[prefix]) additions[prefix] = {};
                    if (aliases.length > 0) aliases.forEach(function(alias) {
                        if (typeof alias === 'string') additions[prefix][alias] = icon;
                    });
                    additions[prefix][iconName] = icon;
                });
                return additions;
            }
        }
    ]);
    return Library;
}();
var $bf68c0e6076612b9$var$_plugins = [];
var $bf68c0e6076612b9$var$_hooks = {};
var $bf68c0e6076612b9$var$providers = {};
var $bf68c0e6076612b9$var$defaultProviderKeys = Object.keys($bf68c0e6076612b9$var$providers);
function $bf68c0e6076612b9$var$registerPlugins(nextPlugins, _ref) {
    var obj = _ref.mixoutsTo;
    $bf68c0e6076612b9$var$_plugins = nextPlugins;
    $bf68c0e6076612b9$var$_hooks = {};
    Object.keys($bf68c0e6076612b9$var$providers).forEach(function(k) {
        if ($bf68c0e6076612b9$var$defaultProviderKeys.indexOf(k) === -1) delete $bf68c0e6076612b9$var$providers[k];
    });
    $bf68c0e6076612b9$var$_plugins.forEach(function(plugin) {
        var mixout = plugin.mixout ? plugin.mixout() : {};
        Object.keys(mixout).forEach(function(tk) {
            if (typeof mixout[tk] === 'function') obj[tk] = mixout[tk];
            if ($bf68c0e6076612b9$var$_typeof(mixout[tk]) === 'object') Object.keys(mixout[tk]).forEach(function(sk) {
                if (!obj[tk]) obj[tk] = {};
                obj[tk][sk] = mixout[tk][sk];
            });
        });
        if (plugin.hooks) {
            var hooks = plugin.hooks();
            Object.keys(hooks).forEach(function(hook) {
                if (!$bf68c0e6076612b9$var$_hooks[hook]) $bf68c0e6076612b9$var$_hooks[hook] = [];
                $bf68c0e6076612b9$var$_hooks[hook].push(hooks[hook]);
            });
        }
        if (plugin.provides) plugin.provides($bf68c0e6076612b9$var$providers);
    });
    return obj;
}
function $bf68c0e6076612b9$var$chainHooks(hook, accumulator) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    var hookFns = $bf68c0e6076612b9$var$_hooks[hook] || [];
    hookFns.forEach(function(hookFn) {
        accumulator = hookFn.apply(null, [
            accumulator
        ].concat(args)); // eslint-disable-line no-useless-call
    });
    return accumulator;
}
function $bf68c0e6076612b9$var$callHooks(hook) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    var hookFns = $bf68c0e6076612b9$var$_hooks[hook] || [];
    hookFns.forEach(function(hookFn) {
        hookFn.apply(null, args);
    });
    return undefined;
}
function $bf68c0e6076612b9$var$callProvided() {
    var hook = arguments[0];
    var args = Array.prototype.slice.call(arguments, 1);
    return $bf68c0e6076612b9$var$providers[hook] ? $bf68c0e6076612b9$var$providers[hook].apply(null, args) : undefined;
}
function $bf68c0e6076612b9$var$findIconDefinition(iconLookup) {
    if (iconLookup.prefix === 'fa') iconLookup.prefix = 'fas';
    var iconName = iconLookup.iconName;
    var prefix = iconLookup.prefix || $bf68c0e6076612b9$var$getDefaultUsablePrefix();
    if (!iconName) return;
    iconName = $bf68c0e6076612b9$var$byAlias(prefix, iconName) || iconName;
    return $bf68c0e6076612b9$var$iconFromMapping($bf68c0e6076612b9$var$library.definitions, prefix, iconName) || $bf68c0e6076612b9$var$iconFromMapping($bf68c0e6076612b9$var$namespace.styles, prefix, iconName);
}
var $bf68c0e6076612b9$var$library = new $bf68c0e6076612b9$var$Library();
var $bf68c0e6076612b9$var$noAuto = function noAuto() {
    $bf68c0e6076612b9$var$config.autoReplaceSvg = false;
    $bf68c0e6076612b9$var$config.observeMutations = false;
    $bf68c0e6076612b9$var$callHooks('noAuto');
};
var $bf68c0e6076612b9$var$dom = {
    i2svg: function i2svg() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if ($bf68c0e6076612b9$var$IS_DOM) {
            $bf68c0e6076612b9$var$callHooks('beforeI2svg', params);
            $bf68c0e6076612b9$var$callProvided('pseudoElements2svg', params);
            return $bf68c0e6076612b9$var$callProvided('i2svg', params);
        } else return Promise.reject('Operation requires a DOM of some kind.');
    },
    watch: function watch() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var autoReplaceSvgRoot = params.autoReplaceSvgRoot;
        if ($bf68c0e6076612b9$var$config.autoReplaceSvg === false) $bf68c0e6076612b9$var$config.autoReplaceSvg = true;
        $bf68c0e6076612b9$var$config.observeMutations = true;
        $bf68c0e6076612b9$var$domready(function() {
            $bf68c0e6076612b9$var$autoReplace({
                autoReplaceSvgRoot: autoReplaceSvgRoot
            });
            $bf68c0e6076612b9$var$callHooks('watch', params);
        });
    }
};
var $bf68c0e6076612b9$var$parse = {
    icon: function icon(_icon) {
        if (_icon === null) return null;
        if ($bf68c0e6076612b9$var$_typeof(_icon) === 'object' && _icon.prefix && _icon.iconName) return {
            prefix: _icon.prefix,
            iconName: $bf68c0e6076612b9$var$byAlias(_icon.prefix, _icon.iconName) || _icon.iconName
        };
        if (Array.isArray(_icon) && _icon.length === 2) {
            var iconName = _icon[1].indexOf('fa-') === 0 ? _icon[1].slice(3) : _icon[1];
            var prefix = $bf68c0e6076612b9$var$getCanonicalPrefix(_icon[0]);
            return {
                prefix: prefix,
                iconName: $bf68c0e6076612b9$var$byAlias(prefix, iconName) || iconName
            };
        }
        if (typeof _icon === 'string' && (_icon.indexOf("".concat($bf68c0e6076612b9$var$config.familyPrefix, "-")) > -1 || _icon.match($bf68c0e6076612b9$var$ICON_SELECTION_SYNTAX_PATTERN))) {
            var canonicalIcon = $bf68c0e6076612b9$var$getCanonicalIcon(_icon.split(' '), {
                skipLookups: true
            });
            return {
                prefix: canonicalIcon.prefix || $bf68c0e6076612b9$var$getDefaultUsablePrefix(),
                iconName: $bf68c0e6076612b9$var$byAlias(canonicalIcon.prefix, canonicalIcon.iconName) || canonicalIcon.iconName
            };
        }
        if (typeof _icon === 'string') {
            var _prefix = $bf68c0e6076612b9$var$getDefaultUsablePrefix();
            return {
                prefix: _prefix,
                iconName: $bf68c0e6076612b9$var$byAlias(_prefix, _icon) || _icon
            };
        }
    }
};
var $bf68c0e6076612b9$export$644d8ea042df96a6 = {
    noAuto: $bf68c0e6076612b9$var$noAuto,
    config: $bf68c0e6076612b9$var$config,
    dom: $bf68c0e6076612b9$var$dom,
    parse: $bf68c0e6076612b9$var$parse,
    library: $bf68c0e6076612b9$var$library,
    findIconDefinition: $bf68c0e6076612b9$var$findIconDefinition,
    toHtml: $bf68c0e6076612b9$var$toHtml
};
var $bf68c0e6076612b9$var$autoReplace = function autoReplace() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _params$autoReplaceSv = params.autoReplaceSvgRoot, autoReplaceSvgRoot = _params$autoReplaceSv === void 0 ? $bf68c0e6076612b9$var$DOCUMENT : _params$autoReplaceSv;
    if ((Object.keys($bf68c0e6076612b9$var$namespace.styles).length > 0 || $bf68c0e6076612b9$var$config.autoFetchSvg) && $bf68c0e6076612b9$var$IS_DOM && $bf68c0e6076612b9$var$config.autoReplaceSvg) $bf68c0e6076612b9$export$644d8ea042df96a6.dom.i2svg({
        node: autoReplaceSvgRoot
    });
};
function $bf68c0e6076612b9$var$domVariants(val, abstractCreator) {
    Object.defineProperty(val, 'abstract', {
        get: abstractCreator
    });
    Object.defineProperty(val, 'html', {
        get: function get() {
            return val.abstract.map(function(a) {
                return $bf68c0e6076612b9$var$toHtml(a);
            });
        }
    });
    Object.defineProperty(val, 'node', {
        get: function get() {
            if (!$bf68c0e6076612b9$var$IS_DOM) return;
            var container = $bf68c0e6076612b9$var$DOCUMENT.createElement('div');
            container.innerHTML = val.html;
            return container.children;
        }
    });
    return val;
}
function $bf68c0e6076612b9$var$asIcon(_ref) {
    var children = _ref.children, main = _ref.main, mask = _ref.mask, attributes = _ref.attributes, styles = _ref.styles, transform = _ref.transform;
    if ($bf68c0e6076612b9$var$transformIsMeaningful(transform) && main.found && !mask.found) {
        var width = main.width, height = main.height;
        var offset = {
            x: width / height / 2,
            y: 0.5
        };
        attributes['style'] = $bf68c0e6076612b9$var$joinStyles($bf68c0e6076612b9$var$_objectSpread2($bf68c0e6076612b9$var$_objectSpread2({}, styles), {}, {
            'transform-origin': "".concat(offset.x + transform.x / 16, "em ").concat(offset.y + transform.y / 16, "em")
        }));
    }
    return [
        {
            tag: 'svg',
            attributes: attributes,
            children: children
        }
    ];
}
function $bf68c0e6076612b9$var$asSymbol(_ref) {
    var prefix = _ref.prefix, iconName = _ref.iconName, children = _ref.children, attributes = _ref.attributes, symbol = _ref.symbol;
    var id = symbol === true ? "".concat(prefix, "-").concat($bf68c0e6076612b9$var$config.familyPrefix, "-").concat(iconName) : symbol;
    return [
        {
            tag: 'svg',
            attributes: {
                style: 'display: none;'
            },
            children: [
                {
                    tag: 'symbol',
                    attributes: $bf68c0e6076612b9$var$_objectSpread2($bf68c0e6076612b9$var$_objectSpread2({}, attributes), {}, {
                        id: id
                    }),
                    children: children
                }
            ]
        }
    ];
}
function $bf68c0e6076612b9$var$makeInlineSvgAbstract(params) {
    var _params$icons = params.icons, main = _params$icons.main, mask = _params$icons.mask, prefix = params.prefix, iconName = params.iconName, transform = params.transform, symbol = params.symbol, title = params.title, maskId = params.maskId, titleId = params.titleId, extra = params.extra, _params$watchable = params.watchable, watchable = _params$watchable === void 0 ? false : _params$watchable;
    var _ref = mask.found ? mask : main, width = _ref.width, height = _ref.height;
    var isUploadedIcon = prefix === 'fak';
    var attrClass = [
        $bf68c0e6076612b9$var$config.replacementClass,
        iconName ? "".concat($bf68c0e6076612b9$var$config.familyPrefix, "-").concat(iconName) : ''
    ].filter(function(c) {
        return extra.classes.indexOf(c) === -1;
    }).filter(function(c) {
        return c !== '' || !!c;
    }).concat(extra.classes).join(' ');
    var content = {
        children: [],
        attributes: $bf68c0e6076612b9$var$_objectSpread2($bf68c0e6076612b9$var$_objectSpread2({}, extra.attributes), {}, {
            'data-prefix': prefix,
            'data-icon': iconName,
            'class': attrClass,
            'role': extra.attributes.role || 'img',
            'xmlns': 'http://www.w3.org/2000/svg',
            'viewBox': "0 0 ".concat(width, " ").concat(height)
        })
    };
    var uploadedIconWidthStyle = isUploadedIcon && !~extra.classes.indexOf('fa-fw') ? {
        width: "".concat(width / height * 1, "em")
    } : {};
    if (watchable) content.attributes[$bf68c0e6076612b9$var$DATA_FA_I2SVG] = '';
    if (title) {
        content.children.push({
            tag: 'title',
            attributes: {
                id: content.attributes['aria-labelledby'] || "title-".concat(titleId || $bf68c0e6076612b9$var$nextUniqueId())
            },
            children: [
                title
            ]
        });
        delete content.attributes.title;
    }
    var args = $bf68c0e6076612b9$var$_objectSpread2($bf68c0e6076612b9$var$_objectSpread2({}, content), {}, {
        prefix: prefix,
        iconName: iconName,
        main: main,
        mask: mask,
        maskId: maskId,
        transform: transform,
        symbol: symbol,
        styles: $bf68c0e6076612b9$var$_objectSpread2($bf68c0e6076612b9$var$_objectSpread2({}, uploadedIconWidthStyle), extra.styles)
    });
    var _ref2 = mask.found && main.found ? $bf68c0e6076612b9$var$callProvided('generateAbstractMask', args) || {
        children: [],
        attributes: {}
    } : $bf68c0e6076612b9$var$callProvided('generateAbstractIcon', args) || {
        children: [],
        attributes: {}
    }, children = _ref2.children, attributes = _ref2.attributes;
    args.children = children;
    args.attributes = attributes;
    if (symbol) return $bf68c0e6076612b9$var$asSymbol(args);
    else return $bf68c0e6076612b9$var$asIcon(args);
}
function $bf68c0e6076612b9$var$makeLayersTextAbstract(params) {
    var content = params.content, width = params.width, height = params.height, transform = params.transform, title = params.title, extra = params.extra, _params$watchable2 = params.watchable, watchable = _params$watchable2 === void 0 ? false : _params$watchable2;
    var attributes = $bf68c0e6076612b9$var$_objectSpread2($bf68c0e6076612b9$var$_objectSpread2($bf68c0e6076612b9$var$_objectSpread2({}, extra.attributes), title ? {
        'title': title
    } : {}), {}, {
        'class': extra.classes.join(' ')
    });
    if (watchable) attributes[$bf68c0e6076612b9$var$DATA_FA_I2SVG] = '';
    var styles = $bf68c0e6076612b9$var$_objectSpread2({}, extra.styles);
    if ($bf68c0e6076612b9$var$transformIsMeaningful(transform)) {
        styles['transform'] = $bf68c0e6076612b9$var$transformForCss({
            transform: transform,
            startCentered: true,
            width: width,
            height: height
        });
        styles['-webkit-transform'] = styles['transform'];
    }
    var styleString = $bf68c0e6076612b9$var$joinStyles(styles);
    if (styleString.length > 0) attributes['style'] = styleString;
    var val = [];
    val.push({
        tag: 'span',
        attributes: attributes,
        children: [
            content
        ]
    });
    if (title) val.push({
        tag: 'span',
        attributes: {
            class: 'sr-only'
        },
        children: [
            title
        ]
    });
    return val;
}
function $bf68c0e6076612b9$var$makeLayersCounterAbstract(params) {
    var content = params.content, title = params.title, extra = params.extra;
    var attributes = $bf68c0e6076612b9$var$_objectSpread2($bf68c0e6076612b9$var$_objectSpread2($bf68c0e6076612b9$var$_objectSpread2({}, extra.attributes), title ? {
        'title': title
    } : {}), {}, {
        'class': extra.classes.join(' ')
    });
    var styleString = $bf68c0e6076612b9$var$joinStyles(extra.styles);
    if (styleString.length > 0) attributes['style'] = styleString;
    var val = [];
    val.push({
        tag: 'span',
        attributes: attributes,
        children: [
            content
        ]
    });
    if (title) val.push({
        tag: 'span',
        attributes: {
            class: 'sr-only'
        },
        children: [
            title
        ]
    });
    return val;
}
var $bf68c0e6076612b9$var$styles$1 = $bf68c0e6076612b9$var$namespace.styles;
function $bf68c0e6076612b9$var$asFoundIcon(icon) {
    var width = icon[0];
    var height = icon[1];
    var _icon$slice = icon.slice(4), _icon$slice2 = $bf68c0e6076612b9$var$_slicedToArray(_icon$slice, 1), vectorData = _icon$slice2[0];
    var element = null;
    if (Array.isArray(vectorData)) element = {
        tag: 'g',
        attributes: {
            class: "".concat($bf68c0e6076612b9$var$config.familyPrefix, "-").concat($bf68c0e6076612b9$var$DUOTONE_CLASSES.GROUP)
        },
        children: [
            {
                tag: 'path',
                attributes: {
                    class: "".concat($bf68c0e6076612b9$var$config.familyPrefix, "-").concat($bf68c0e6076612b9$var$DUOTONE_CLASSES.SECONDARY),
                    fill: 'currentColor',
                    d: vectorData[0]
                }
            },
            {
                tag: 'path',
                attributes: {
                    class: "".concat($bf68c0e6076612b9$var$config.familyPrefix, "-").concat($bf68c0e6076612b9$var$DUOTONE_CLASSES.PRIMARY),
                    fill: 'currentColor',
                    d: vectorData[1]
                }
            }
        ]
    };
    else element = {
        tag: 'path',
        attributes: {
            fill: 'currentColor',
            d: vectorData
        }
    };
    return {
        found: true,
        width: width,
        height: height,
        icon: element
    };
}
var $bf68c0e6076612b9$var$missingIconResolutionMixin = {
    found: false,
    width: 512,
    height: 512
};
function $bf68c0e6076612b9$var$maybeNotifyMissing(iconName, prefix) {
    if (!$bf68c0e6076612b9$var$PRODUCTION && !$bf68c0e6076612b9$var$config.showMissingIcons && iconName) console.error("Icon with name \"".concat(iconName, "\" and prefix \"").concat(prefix, "\" is missing."));
}
function $bf68c0e6076612b9$var$findIcon(iconName, prefix) {
    var givenPrefix = prefix;
    if (prefix === 'fa' && $bf68c0e6076612b9$var$config.styleDefault !== null) prefix = $bf68c0e6076612b9$var$getDefaultUsablePrefix();
    return new Promise(function(resolve, reject) {
        var val = {
            found: false,
            width: 512,
            height: 512,
            icon: $bf68c0e6076612b9$var$callProvided('missingIconAbstract') || {}
        };
        if (givenPrefix === 'fa') {
            var shim = $bf68c0e6076612b9$var$byOldName(iconName) || {};
            iconName = shim.iconName || iconName;
            prefix = shim.prefix || prefix;
        }
        if (iconName && prefix && $bf68c0e6076612b9$var$styles$1[prefix] && $bf68c0e6076612b9$var$styles$1[prefix][iconName]) {
            var icon = $bf68c0e6076612b9$var$styles$1[prefix][iconName];
            return resolve($bf68c0e6076612b9$var$asFoundIcon(icon));
        }
        $bf68c0e6076612b9$var$maybeNotifyMissing(iconName, prefix);
        resolve($bf68c0e6076612b9$var$_objectSpread2($bf68c0e6076612b9$var$_objectSpread2({}, $bf68c0e6076612b9$var$missingIconResolutionMixin), {}, {
            icon: $bf68c0e6076612b9$var$config.showMissingIcons && iconName ? $bf68c0e6076612b9$var$callProvided('missingIconAbstract') || {} : {}
        }));
    });
}
var $bf68c0e6076612b9$var$noop$1 = function noop() {};
var $bf68c0e6076612b9$var$p = $bf68c0e6076612b9$var$config.measurePerformance && $bf68c0e6076612b9$var$PERFORMANCE && $bf68c0e6076612b9$var$PERFORMANCE.mark && $bf68c0e6076612b9$var$PERFORMANCE.measure ? $bf68c0e6076612b9$var$PERFORMANCE : {
    mark: $bf68c0e6076612b9$var$noop$1,
    measure: $bf68c0e6076612b9$var$noop$1
};
var $bf68c0e6076612b9$var$preamble = "FA \"6.0.0\"";
var $bf68c0e6076612b9$var$begin = function begin(name) {
    $bf68c0e6076612b9$var$p.mark("".concat($bf68c0e6076612b9$var$preamble, " ").concat(name, " begins"));
    return function() {
        return $bf68c0e6076612b9$var$end(name);
    };
};
var $bf68c0e6076612b9$var$end = function end(name) {
    $bf68c0e6076612b9$var$p.mark("".concat($bf68c0e6076612b9$var$preamble, " ").concat(name, " ends"));
    $bf68c0e6076612b9$var$p.measure("".concat($bf68c0e6076612b9$var$preamble, " ").concat(name), "".concat($bf68c0e6076612b9$var$preamble, " ").concat(name, " begins"), "".concat($bf68c0e6076612b9$var$preamble, " ").concat(name, " ends"));
};
var $bf68c0e6076612b9$var$perf = {
    begin: $bf68c0e6076612b9$var$begin,
    end: $bf68c0e6076612b9$var$end
};
var $bf68c0e6076612b9$var$noop$2 = function noop() {};
function $bf68c0e6076612b9$var$isWatched(node) {
    var i2svg = node.getAttribute ? node.getAttribute($bf68c0e6076612b9$var$DATA_FA_I2SVG) : null;
    return typeof i2svg === 'string';
}
function $bf68c0e6076612b9$var$hasPrefixAndIcon(node) {
    var prefix = node.getAttribute ? node.getAttribute($bf68c0e6076612b9$var$DATA_PREFIX) : null;
    var icon = node.getAttribute ? node.getAttribute($bf68c0e6076612b9$var$DATA_ICON) : null;
    return prefix && icon;
}
function $bf68c0e6076612b9$var$hasBeenReplaced(node) {
    return node && node.classList && node.classList.contains && node.classList.contains($bf68c0e6076612b9$var$config.replacementClass);
}
function $bf68c0e6076612b9$var$getMutator() {
    if ($bf68c0e6076612b9$var$config.autoReplaceSvg === true) return $bf68c0e6076612b9$var$mutators.replace;
    var mutator = $bf68c0e6076612b9$var$mutators[$bf68c0e6076612b9$var$config.autoReplaceSvg];
    return mutator || $bf68c0e6076612b9$var$mutators.replace;
}
function $bf68c0e6076612b9$var$createElementNS(tag) {
    return $bf68c0e6076612b9$var$DOCUMENT.createElementNS('http://www.w3.org/2000/svg', tag);
}
function $bf68c0e6076612b9$var$createElement(tag) {
    return $bf68c0e6076612b9$var$DOCUMENT.createElement(tag);
}
function $bf68c0e6076612b9$var$convertSVG(abstractObj) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$ceFn = params.ceFn, ceFn = _params$ceFn === void 0 ? abstractObj.tag === 'svg' ? $bf68c0e6076612b9$var$createElementNS : $bf68c0e6076612b9$var$createElement : _params$ceFn;
    if (typeof abstractObj === 'string') return $bf68c0e6076612b9$var$DOCUMENT.createTextNode(abstractObj);
    var tag = ceFn(abstractObj.tag);
    Object.keys(abstractObj.attributes || []).forEach(function(key) {
        tag.setAttribute(key, abstractObj.attributes[key]);
    });
    var children = abstractObj.children || [];
    children.forEach(function(child) {
        tag.appendChild($bf68c0e6076612b9$var$convertSVG(child, {
            ceFn: ceFn
        }));
    });
    return tag;
}
function $bf68c0e6076612b9$var$nodeAsComment(node) {
    var comment = " ".concat(node.outerHTML, " ");
    /* BEGIN.ATTRIBUTION */ comment = "".concat(comment, "Font Awesome fontawesome.com ");
    /* END.ATTRIBUTION */ return comment;
}
var $bf68c0e6076612b9$var$mutators = {
    replace: function replace(mutation) {
        var node = mutation[0];
        if (node.parentNode) {
            mutation[1].forEach(function(abstract) {
                node.parentNode.insertBefore($bf68c0e6076612b9$var$convertSVG(abstract), node);
            });
            if (node.getAttribute($bf68c0e6076612b9$var$DATA_FA_I2SVG) === null && $bf68c0e6076612b9$var$config.keepOriginalSource) {
                var comment = $bf68c0e6076612b9$var$DOCUMENT.createComment($bf68c0e6076612b9$var$nodeAsComment(node));
                node.parentNode.replaceChild(comment, node);
            } else node.remove();
        }
    },
    nest: function nest(mutation) {
        var node = mutation[0];
        var abstract = mutation[1]; // If we already have a replaced node we do not want to continue nesting within it.
        // Short-circuit to the standard replacement
        if (~$bf68c0e6076612b9$var$classArray(node).indexOf($bf68c0e6076612b9$var$config.replacementClass)) return $bf68c0e6076612b9$var$mutators.replace(mutation);
        var forSvg = new RegExp("".concat($bf68c0e6076612b9$var$config.familyPrefix, "-.*"));
        delete abstract[0].attributes.id;
        if (abstract[0].attributes.class) {
            var splitClasses = abstract[0].attributes.class.split(' ').reduce(function(acc, cls) {
                if (cls === $bf68c0e6076612b9$var$config.replacementClass || cls.match(forSvg)) acc.toSvg.push(cls);
                else acc.toNode.push(cls);
                return acc;
            }, {
                toNode: [],
                toSvg: []
            });
            abstract[0].attributes.class = splitClasses.toSvg.join(' ');
            if (splitClasses.toNode.length === 0) node.removeAttribute('class');
            else node.setAttribute('class', splitClasses.toNode.join(' '));
        }
        var newInnerHTML = abstract.map(function(a) {
            return $bf68c0e6076612b9$var$toHtml(a);
        }).join('\n');
        node.setAttribute($bf68c0e6076612b9$var$DATA_FA_I2SVG, '');
        node.innerHTML = newInnerHTML;
    }
};
function $bf68c0e6076612b9$var$performOperationSync(op) {
    op();
}
function $bf68c0e6076612b9$var$perform(mutations, callback) {
    var callbackFunction = typeof callback === 'function' ? callback : $bf68c0e6076612b9$var$noop$2;
    if (mutations.length === 0) callbackFunction();
    else {
        var frame = $bf68c0e6076612b9$var$performOperationSync;
        if ($bf68c0e6076612b9$var$config.mutateApproach === $bf68c0e6076612b9$var$MUTATION_APPROACH_ASYNC) frame = $bf68c0e6076612b9$var$WINDOW.requestAnimationFrame || $bf68c0e6076612b9$var$performOperationSync;
        frame(function() {
            var mutator = $bf68c0e6076612b9$var$getMutator();
            var mark = $bf68c0e6076612b9$var$perf.begin('mutate');
            mutations.map(mutator);
            mark();
            callbackFunction();
        });
    }
}
var $bf68c0e6076612b9$var$disabled = false;
function $bf68c0e6076612b9$var$disableObservation() {
    $bf68c0e6076612b9$var$disabled = true;
}
function $bf68c0e6076612b9$var$enableObservation() {
    $bf68c0e6076612b9$var$disabled = false;
}
var $bf68c0e6076612b9$var$mo = null;
function $bf68c0e6076612b9$var$observe(options) {
    if (!$bf68c0e6076612b9$var$MUTATION_OBSERVER) return;
    if (!$bf68c0e6076612b9$var$config.observeMutations) return;
    var _options$treeCallback = options.treeCallback, treeCallback = _options$treeCallback === void 0 ? $bf68c0e6076612b9$var$noop$2 : _options$treeCallback, _options$nodeCallback = options.nodeCallback, nodeCallback = _options$nodeCallback === void 0 ? $bf68c0e6076612b9$var$noop$2 : _options$nodeCallback, _options$pseudoElemen = options.pseudoElementsCallback, pseudoElementsCallback = _options$pseudoElemen === void 0 ? $bf68c0e6076612b9$var$noop$2 : _options$pseudoElemen, _options$observeMutat = options.observeMutationsRoot, observeMutationsRoot = _options$observeMutat === void 0 ? $bf68c0e6076612b9$var$DOCUMENT : _options$observeMutat;
    $bf68c0e6076612b9$var$mo = new $bf68c0e6076612b9$var$MUTATION_OBSERVER(function(objects) {
        if ($bf68c0e6076612b9$var$disabled) return;
        var defaultPrefix = $bf68c0e6076612b9$var$getDefaultUsablePrefix();
        $bf68c0e6076612b9$var$toArray(objects).forEach(function(mutationRecord) {
            if (mutationRecord.type === 'childList' && mutationRecord.addedNodes.length > 0 && !$bf68c0e6076612b9$var$isWatched(mutationRecord.addedNodes[0])) {
                if ($bf68c0e6076612b9$var$config.searchPseudoElements) pseudoElementsCallback(mutationRecord.target);
                treeCallback(mutationRecord.target);
            }
            if (mutationRecord.type === 'attributes' && mutationRecord.target.parentNode && $bf68c0e6076612b9$var$config.searchPseudoElements) pseudoElementsCallback(mutationRecord.target.parentNode);
            if (mutationRecord.type === 'attributes' && $bf68c0e6076612b9$var$isWatched(mutationRecord.target) && ~$bf68c0e6076612b9$var$ATTRIBUTES_WATCHED_FOR_MUTATION.indexOf(mutationRecord.attributeName)) {
                if (mutationRecord.attributeName === 'class' && $bf68c0e6076612b9$var$hasPrefixAndIcon(mutationRecord.target)) {
                    var _getCanonicalIcon = $bf68c0e6076612b9$var$getCanonicalIcon($bf68c0e6076612b9$var$classArray(mutationRecord.target)), prefix = _getCanonicalIcon.prefix, iconName = _getCanonicalIcon.iconName;
                    mutationRecord.target.setAttribute($bf68c0e6076612b9$var$DATA_PREFIX, prefix || defaultPrefix);
                    if (iconName) mutationRecord.target.setAttribute($bf68c0e6076612b9$var$DATA_ICON, iconName);
                } else if ($bf68c0e6076612b9$var$hasBeenReplaced(mutationRecord.target)) nodeCallback(mutationRecord.target);
            }
        });
    });
    if (!$bf68c0e6076612b9$var$IS_DOM) return;
    $bf68c0e6076612b9$var$mo.observe(observeMutationsRoot, {
        childList: true,
        attributes: true,
        characterData: true,
        subtree: true
    });
}
function $bf68c0e6076612b9$var$disconnect() {
    if (!$bf68c0e6076612b9$var$mo) return;
    $bf68c0e6076612b9$var$mo.disconnect();
}
function $bf68c0e6076612b9$var$styleParser(node) {
    var style = node.getAttribute('style');
    var val = [];
    if (style) val = style.split(';').reduce(function(acc, style) {
        var styles = style.split(':');
        var prop = styles[0];
        var value = styles.slice(1);
        if (prop && value.length > 0) acc[prop] = value.join(':').trim();
        return acc;
    }, {});
    return val;
}
function $bf68c0e6076612b9$var$classParser(node) {
    var existingPrefix = node.getAttribute('data-prefix');
    var existingIconName = node.getAttribute('data-icon');
    var innerText = node.innerText !== undefined ? node.innerText.trim() : '';
    var val = $bf68c0e6076612b9$var$getCanonicalIcon($bf68c0e6076612b9$var$classArray(node));
    if (!val.prefix) val.prefix = $bf68c0e6076612b9$var$getDefaultUsablePrefix();
    if (existingPrefix && existingIconName) {
        val.prefix = existingPrefix;
        val.iconName = existingIconName;
    }
    if (val.iconName && val.prefix) return val;
    if (val.prefix && innerText.length > 0) val.iconName = $bf68c0e6076612b9$var$byLigature(val.prefix, node.innerText) || $bf68c0e6076612b9$var$byUnicode(val.prefix, $bf68c0e6076612b9$var$toHex(node.innerText));
    return val;
}
function $bf68c0e6076612b9$var$attributesParser(node) {
    var extraAttributes = $bf68c0e6076612b9$var$toArray(node.attributes).reduce(function(acc, attr) {
        if (acc.name !== 'class' && acc.name !== 'style') acc[attr.name] = attr.value;
        return acc;
    }, {});
    var title = node.getAttribute('title');
    var titleId = node.getAttribute('data-fa-title-id');
    if ($bf68c0e6076612b9$var$config.autoA11y) {
        if (title) extraAttributes['aria-labelledby'] = "".concat($bf68c0e6076612b9$var$config.replacementClass, "-title-").concat(titleId || $bf68c0e6076612b9$var$nextUniqueId());
        else {
            extraAttributes['aria-hidden'] = 'true';
            extraAttributes['focusable'] = 'false';
        }
    }
    return extraAttributes;
}
function $bf68c0e6076612b9$var$blankMeta() {
    return {
        iconName: null,
        title: null,
        titleId: null,
        prefix: null,
        transform: $bf68c0e6076612b9$var$meaninglessTransform,
        symbol: false,
        mask: {
            iconName: null,
            prefix: null,
            rest: []
        },
        maskId: null,
        extra: {
            classes: [],
            styles: {},
            attributes: {}
        }
    };
}
function $bf68c0e6076612b9$var$parseMeta(node) {
    var parser = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        styleParser: true
    };
    var _classParser = $bf68c0e6076612b9$var$classParser(node), iconName = _classParser.iconName, prefix = _classParser.prefix, extraClasses = _classParser.rest;
    var extraAttributes = $bf68c0e6076612b9$var$attributesParser(node);
    var pluginMeta = $bf68c0e6076612b9$var$chainHooks('parseNodeAttributes', {}, node);
    var extraStyles = parser.styleParser ? $bf68c0e6076612b9$var$styleParser(node) : [];
    return $bf68c0e6076612b9$var$_objectSpread2({
        iconName: iconName,
        title: node.getAttribute('title'),
        titleId: node.getAttribute('data-fa-title-id'),
        prefix: prefix,
        transform: $bf68c0e6076612b9$var$meaninglessTransform,
        mask: {
            iconName: null,
            prefix: null,
            rest: []
        },
        maskId: null,
        symbol: false,
        extra: {
            classes: extraClasses,
            styles: extraStyles,
            attributes: extraAttributes
        }
    }, pluginMeta);
}
var $bf68c0e6076612b9$var$styles$2 = $bf68c0e6076612b9$var$namespace.styles;
function $bf68c0e6076612b9$var$generateMutation(node) {
    var nodeMeta = $bf68c0e6076612b9$var$config.autoReplaceSvg === 'nest' ? $bf68c0e6076612b9$var$parseMeta(node, {
        styleParser: false
    }) : $bf68c0e6076612b9$var$parseMeta(node);
    if (~nodeMeta.extra.classes.indexOf($bf68c0e6076612b9$var$LAYERS_TEXT_CLASSNAME)) return $bf68c0e6076612b9$var$callProvided('generateLayersText', node, nodeMeta);
    else return $bf68c0e6076612b9$var$callProvided('generateSvgReplacementMutation', node, nodeMeta);
}
function $bf68c0e6076612b9$var$onTree(root) {
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    if (!$bf68c0e6076612b9$var$IS_DOM) return Promise.resolve();
    var htmlClassList = $bf68c0e6076612b9$var$DOCUMENT.documentElement.classList;
    var hclAdd = function hclAdd(suffix) {
        return htmlClassList.add("".concat($bf68c0e6076612b9$var$HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
    };
    var hclRemove = function hclRemove(suffix) {
        return htmlClassList.remove("".concat($bf68c0e6076612b9$var$HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
    };
    var prefixes = $bf68c0e6076612b9$var$config.autoFetchSvg ? Object.keys($bf68c0e6076612b9$var$PREFIX_TO_STYLE) : Object.keys($bf68c0e6076612b9$var$styles$2);
    var prefixesDomQuery = [
        ".".concat($bf68c0e6076612b9$var$LAYERS_TEXT_CLASSNAME, ":not([").concat($bf68c0e6076612b9$var$DATA_FA_I2SVG, "])")
    ].concat(prefixes.map(function(p) {
        return ".".concat(p, ":not([").concat($bf68c0e6076612b9$var$DATA_FA_I2SVG, "])");
    })).join(', ');
    if (prefixesDomQuery.length === 0) return Promise.resolve();
    var candidates = [];
    try {
        candidates = $bf68c0e6076612b9$var$toArray(root.querySelectorAll(prefixesDomQuery));
    } catch (e) {}
    if (candidates.length > 0) {
        hclAdd('pending');
        hclRemove('complete');
    } else return Promise.resolve();
    var mark = $bf68c0e6076612b9$var$perf.begin('onTree');
    var mutations = candidates.reduce(function(acc, node) {
        try {
            var mutation = $bf68c0e6076612b9$var$generateMutation(node);
            if (mutation) acc.push(mutation);
        } catch (e) {
            if (!$bf68c0e6076612b9$var$PRODUCTION) {
                if (e.name === 'MissingIcon') console.error(e);
            }
        }
        return acc;
    }, []);
    return new Promise(function(resolve, reject) {
        Promise.all(mutations).then(function(resolvedMutations) {
            $bf68c0e6076612b9$var$perform(resolvedMutations, function() {
                hclAdd('active');
                hclAdd('complete');
                hclRemove('pending');
                if (typeof callback === 'function') callback();
                mark();
                resolve();
            });
        }).catch(function(e) {
            mark();
            reject(e);
        });
    });
}
function $bf68c0e6076612b9$var$onNode(node) {
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    $bf68c0e6076612b9$var$generateMutation(node).then(function(mutation) {
        if (mutation) $bf68c0e6076612b9$var$perform([
            mutation
        ], callback);
    });
}
function $bf68c0e6076612b9$var$resolveIcons(next) {
    return function(maybeIconDefinition) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var iconDefinition = (maybeIconDefinition || {}).icon ? maybeIconDefinition : $bf68c0e6076612b9$var$findIconDefinition(maybeIconDefinition || {});
        var mask = params.mask;
        if (mask) mask = (mask || {}).icon ? mask : $bf68c0e6076612b9$var$findIconDefinition(mask || {});
        return next(iconDefinition, $bf68c0e6076612b9$var$_objectSpread2($bf68c0e6076612b9$var$_objectSpread2({}, params), {}, {
            mask: mask
        }));
    };
}
var $bf68c0e6076612b9$var$render = function render(iconDefinition) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$transform = params.transform, transform = _params$transform === void 0 ? $bf68c0e6076612b9$var$meaninglessTransform : _params$transform, _params$symbol = params.symbol, symbol = _params$symbol === void 0 ? false : _params$symbol, _params$mask = params.mask, mask = _params$mask === void 0 ? null : _params$mask, _params$maskId = params.maskId, maskId = _params$maskId === void 0 ? null : _params$maskId, _params$title = params.title, title = _params$title === void 0 ? null : _params$title, _params$titleId = params.titleId, titleId = _params$titleId === void 0 ? null : _params$titleId, _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes, _params$attributes = params.attributes, attributes = _params$attributes === void 0 ? {} : _params$attributes, _params$styles = params.styles, styles = _params$styles === void 0 ? {} : _params$styles;
    if (!iconDefinition) return;
    var prefix = iconDefinition.prefix, iconName = iconDefinition.iconName, icon = iconDefinition.icon;
    return $bf68c0e6076612b9$var$domVariants($bf68c0e6076612b9$var$_objectSpread2({
        type: 'icon'
    }, iconDefinition), function() {
        $bf68c0e6076612b9$var$callHooks('beforeDOMElementCreation', {
            iconDefinition: iconDefinition,
            params: params
        });
        if ($bf68c0e6076612b9$var$config.autoA11y) {
            if (title) attributes['aria-labelledby'] = "".concat($bf68c0e6076612b9$var$config.replacementClass, "-title-").concat(titleId || $bf68c0e6076612b9$var$nextUniqueId());
            else {
                attributes['aria-hidden'] = 'true';
                attributes['focusable'] = 'false';
            }
        }
        return $bf68c0e6076612b9$var$makeInlineSvgAbstract({
            icons: {
                main: $bf68c0e6076612b9$var$asFoundIcon(icon),
                mask: mask ? $bf68c0e6076612b9$var$asFoundIcon(mask.icon) : {
                    found: false,
                    width: null,
                    height: null,
                    icon: {}
                }
            },
            prefix: prefix,
            iconName: iconName,
            transform: $bf68c0e6076612b9$var$_objectSpread2($bf68c0e6076612b9$var$_objectSpread2({}, $bf68c0e6076612b9$var$meaninglessTransform), transform),
            symbol: symbol,
            title: title,
            maskId: maskId,
            titleId: titleId,
            extra: {
                attributes: attributes,
                styles: styles,
                classes: classes
            }
        });
    });
};
var $bf68c0e6076612b9$var$ReplaceElements = {
    mixout: function mixout() {
        return {
            icon: $bf68c0e6076612b9$var$resolveIcons($bf68c0e6076612b9$var$render)
        };
    },
    hooks: function hooks() {
        return {
            mutationObserverCallbacks: function mutationObserverCallbacks(accumulator) {
                accumulator.treeCallback = $bf68c0e6076612b9$var$onTree;
                accumulator.nodeCallback = $bf68c0e6076612b9$var$onNode;
                return accumulator;
            }
        };
    },
    provides: function provides(providers$$1) {
        providers$$1.i2svg = function(params) {
            var _params$node = params.node, node = _params$node === void 0 ? $bf68c0e6076612b9$var$DOCUMENT : _params$node, _params$callback = params.callback, callback = _params$callback === void 0 ? function callback() {} : _params$callback;
            return $bf68c0e6076612b9$var$onTree(node, callback);
        };
        providers$$1.generateSvgReplacementMutation = function(node, nodeMeta) {
            var iconName = nodeMeta.iconName, title = nodeMeta.title, titleId = nodeMeta.titleId, prefix = nodeMeta.prefix, transform = nodeMeta.transform, symbol = nodeMeta.symbol, mask = nodeMeta.mask, maskId = nodeMeta.maskId, extra = nodeMeta.extra;
            return new Promise(function(resolve, reject) {
                Promise.all([
                    $bf68c0e6076612b9$var$findIcon(iconName, prefix),
                    mask.iconName ? $bf68c0e6076612b9$var$findIcon(mask.iconName, mask.prefix) : Promise.resolve({
                        found: false,
                        width: 512,
                        height: 512,
                        icon: {}
                    })
                ]).then(function(_ref) {
                    var _ref2 = $bf68c0e6076612b9$var$_slicedToArray(_ref, 2), main = _ref2[0], mask = _ref2[1];
                    resolve([
                        node,
                        $bf68c0e6076612b9$var$makeInlineSvgAbstract({
                            icons: {
                                main: main,
                                mask: mask
                            },
                            prefix: prefix,
                            iconName: iconName,
                            transform: transform,
                            symbol: symbol,
                            maskId: maskId,
                            title: title,
                            titleId: titleId,
                            extra: extra,
                            watchable: true
                        })
                    ]);
                }).catch(reject);
            });
        };
        providers$$1.generateAbstractIcon = function(_ref3) {
            var children = _ref3.children, attributes = _ref3.attributes, main = _ref3.main, transform = _ref3.transform, styles = _ref3.styles;
            var styleString = $bf68c0e6076612b9$var$joinStyles(styles);
            if (styleString.length > 0) attributes['style'] = styleString;
            var nextChild;
            if ($bf68c0e6076612b9$var$transformIsMeaningful(transform)) nextChild = $bf68c0e6076612b9$var$callProvided('generateAbstractTransformGrouping', {
                main: main,
                transform: transform,
                containerWidth: main.width,
                iconWidth: main.width
            });
            children.push(nextChild || main.icon);
            return {
                children: children,
                attributes: attributes
            };
        };
    }
};
var $bf68c0e6076612b9$var$Layers = {
    mixout: function mixout() {
        return {
            layer: function layer(assembler) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes;
                return $bf68c0e6076612b9$var$domVariants({
                    type: 'layer'
                }, function() {
                    $bf68c0e6076612b9$var$callHooks('beforeDOMElementCreation', {
                        assembler: assembler,
                        params: params
                    });
                    var children = [];
                    assembler(function(args) {
                        Array.isArray(args) ? args.map(function(a) {
                            children = children.concat(a.abstract);
                        }) : children = children.concat(args.abstract);
                    });
                    return [
                        {
                            tag: 'span',
                            attributes: {
                                class: [
                                    "".concat($bf68c0e6076612b9$var$config.familyPrefix, "-layers")
                                ].concat($bf68c0e6076612b9$var$_toConsumableArray(classes)).join(' ')
                            },
                            children: children
                        }
                    ];
                });
            }
        };
    }
};
var $bf68c0e6076612b9$var$LayersCounter = {
    mixout: function mixout() {
        return {
            counter: function counter(content) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var _params$title = params.title, title = _params$title === void 0 ? null : _params$title, _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes, _params$attributes = params.attributes, attributes = _params$attributes === void 0 ? {} : _params$attributes, _params$styles = params.styles, styles = _params$styles === void 0 ? {} : _params$styles;
                return $bf68c0e6076612b9$var$domVariants({
                    type: 'counter',
                    content: content
                }, function() {
                    $bf68c0e6076612b9$var$callHooks('beforeDOMElementCreation', {
                        content: content,
                        params: params
                    });
                    return $bf68c0e6076612b9$var$makeLayersCounterAbstract({
                        content: content.toString(),
                        title: title,
                        extra: {
                            attributes: attributes,
                            styles: styles,
                            classes: [
                                "".concat($bf68c0e6076612b9$var$config.familyPrefix, "-layers-counter")
                            ].concat($bf68c0e6076612b9$var$_toConsumableArray(classes))
                        }
                    });
                });
            }
        };
    }
};
var $bf68c0e6076612b9$var$LayersText = {
    mixout: function mixout() {
        return {
            text: function text(content) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var _params$transform = params.transform, transform = _params$transform === void 0 ? $bf68c0e6076612b9$var$meaninglessTransform : _params$transform, _params$title = params.title, title = _params$title === void 0 ? null : _params$title, _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes, _params$attributes = params.attributes, attributes = _params$attributes === void 0 ? {} : _params$attributes, _params$styles = params.styles, styles = _params$styles === void 0 ? {} : _params$styles;
                return $bf68c0e6076612b9$var$domVariants({
                    type: 'text',
                    content: content
                }, function() {
                    $bf68c0e6076612b9$var$callHooks('beforeDOMElementCreation', {
                        content: content,
                        params: params
                    });
                    return $bf68c0e6076612b9$var$makeLayersTextAbstract({
                        content: content,
                        transform: $bf68c0e6076612b9$var$_objectSpread2($bf68c0e6076612b9$var$_objectSpread2({}, $bf68c0e6076612b9$var$meaninglessTransform), transform),
                        title: title,
                        extra: {
                            attributes: attributes,
                            styles: styles,
                            classes: [
                                "".concat($bf68c0e6076612b9$var$config.familyPrefix, "-layers-text")
                            ].concat($bf68c0e6076612b9$var$_toConsumableArray(classes))
                        }
                    });
                });
            }
        };
    },
    provides: function provides(providers$$1) {
        providers$$1.generateLayersText = function(node, nodeMeta) {
            var title = nodeMeta.title, transform = nodeMeta.transform, extra = nodeMeta.extra;
            var width = null;
            var height = null;
            if ($bf68c0e6076612b9$var$IS_IE) {
                var computedFontSize = parseInt(getComputedStyle(node).fontSize, 10);
                var boundingClientRect = node.getBoundingClientRect();
                width = boundingClientRect.width / computedFontSize;
                height = boundingClientRect.height / computedFontSize;
            }
            if ($bf68c0e6076612b9$var$config.autoA11y && !title) extra.attributes['aria-hidden'] = 'true';
            return Promise.resolve([
                node,
                $bf68c0e6076612b9$var$makeLayersTextAbstract({
                    content: node.innerHTML,
                    width: width,
                    height: height,
                    transform: transform,
                    title: title,
                    extra: extra,
                    watchable: true
                })
            ]);
        };
    }
};
var $bf68c0e6076612b9$var$CLEAN_CONTENT_PATTERN = new RegExp("\"", 'ug');
var $bf68c0e6076612b9$var$SECONDARY_UNICODE_RANGE = [
    1105920,
    1112319
];
function $bf68c0e6076612b9$var$hexValueFromContent(content) {
    var cleaned = content.replace($bf68c0e6076612b9$var$CLEAN_CONTENT_PATTERN, '');
    var codePoint = $bf68c0e6076612b9$var$codePointAt(cleaned, 0);
    var isPrependTen = codePoint >= $bf68c0e6076612b9$var$SECONDARY_UNICODE_RANGE[0] && codePoint <= $bf68c0e6076612b9$var$SECONDARY_UNICODE_RANGE[1];
    var isDoubled = cleaned.length === 2 ? cleaned[0] === cleaned[1] : false;
    return {
        value: isDoubled ? $bf68c0e6076612b9$var$toHex(cleaned[0]) : $bf68c0e6076612b9$var$toHex(cleaned),
        isSecondary: isPrependTen || isDoubled
    };
}
function $bf68c0e6076612b9$var$replaceForPosition(node, position) {
    var pendingAttribute = "".concat($bf68c0e6076612b9$var$DATA_FA_PSEUDO_ELEMENT_PENDING).concat(position.replace(':', '-'));
    return new Promise(function(resolve, reject) {
        if (node.getAttribute(pendingAttribute) !== null) // This node is already being processed
        return resolve();
        var children = $bf68c0e6076612b9$var$toArray(node.children);
        var alreadyProcessedPseudoElement = children.filter(function(c) {
            return c.getAttribute($bf68c0e6076612b9$var$DATA_FA_PSEUDO_ELEMENT) === position;
        })[0];
        var styles = $bf68c0e6076612b9$var$WINDOW.getComputedStyle(node, position);
        var fontFamily = styles.getPropertyValue('font-family').match($bf68c0e6076612b9$var$FONT_FAMILY_PATTERN);
        var fontWeight = styles.getPropertyValue('font-weight');
        var content = styles.getPropertyValue('content');
        if (alreadyProcessedPseudoElement && !fontFamily) {
            // If we've already processed it but the current computed style does not result in a font-family,
            // that probably means that a class name that was previously present to make the icon has been
            // removed. So we now should delete the icon.
            node.removeChild(alreadyProcessedPseudoElement);
            return resolve();
        } else if (fontFamily && content !== 'none' && content !== '') {
            var _content = styles.getPropertyValue('content');
            var prefix = ~[
                'Solid',
                'Regular',
                'Light',
                'Thin',
                'Duotone',
                'Brands',
                'Kit'
            ].indexOf(fontFamily[2]) ? $bf68c0e6076612b9$var$STYLE_TO_PREFIX[fontFamily[2].toLowerCase()] : $bf68c0e6076612b9$var$FONT_WEIGHT_TO_PREFIX[fontWeight];
            var _hexValueFromContent = $bf68c0e6076612b9$var$hexValueFromContent(_content), hexValue = _hexValueFromContent.value, isSecondary = _hexValueFromContent.isSecondary;
            var isV4 = fontFamily[0].startsWith('FontAwesome');
            var iconName = $bf68c0e6076612b9$var$byUnicode(prefix, hexValue);
            var iconIdentifier = iconName;
            if (isV4) {
                var iconName4 = $bf68c0e6076612b9$var$byOldUnicode(hexValue);
                if (iconName4.iconName && iconName4.prefix) {
                    iconName = iconName4.iconName;
                    prefix = iconName4.prefix;
                }
            } // Only convert the pseudo element in this ::before/::after position into an icon if we haven't
            // already done so with the same prefix and iconName
            if (iconName && !isSecondary && (!alreadyProcessedPseudoElement || alreadyProcessedPseudoElement.getAttribute($bf68c0e6076612b9$var$DATA_PREFIX) !== prefix || alreadyProcessedPseudoElement.getAttribute($bf68c0e6076612b9$var$DATA_ICON) !== iconIdentifier)) {
                node.setAttribute(pendingAttribute, iconIdentifier);
                if (alreadyProcessedPseudoElement) // Delete the old one, since we're replacing it with a new one
                node.removeChild(alreadyProcessedPseudoElement);
                var meta = $bf68c0e6076612b9$var$blankMeta();
                var extra = meta.extra;
                extra.attributes[$bf68c0e6076612b9$var$DATA_FA_PSEUDO_ELEMENT] = position;
                $bf68c0e6076612b9$var$findIcon(iconName, prefix).then(function(main) {
                    var abstract = $bf68c0e6076612b9$var$makeInlineSvgAbstract($bf68c0e6076612b9$var$_objectSpread2($bf68c0e6076612b9$var$_objectSpread2({}, meta), {}, {
                        icons: {
                            main: main,
                            mask: $bf68c0e6076612b9$var$emptyCanonicalIcon()
                        },
                        prefix: prefix,
                        iconName: iconIdentifier,
                        extra: extra,
                        watchable: true
                    }));
                    var element = $bf68c0e6076612b9$var$DOCUMENT.createElement('svg');
                    if (position === '::before') node.insertBefore(element, node.firstChild);
                    else node.appendChild(element);
                    element.outerHTML = abstract.map(function(a) {
                        return $bf68c0e6076612b9$var$toHtml(a);
                    }).join('\n');
                    node.removeAttribute(pendingAttribute);
                    resolve();
                }).catch(reject);
            } else resolve();
        } else resolve();
    });
}
function $bf68c0e6076612b9$var$replace(node) {
    return Promise.all([
        $bf68c0e6076612b9$var$replaceForPosition(node, '::before'),
        $bf68c0e6076612b9$var$replaceForPosition(node, '::after')
    ]);
}
function $bf68c0e6076612b9$var$processable(node) {
    return node.parentNode !== document.head && !~$bf68c0e6076612b9$var$TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS.indexOf(node.tagName.toUpperCase()) && !node.getAttribute($bf68c0e6076612b9$var$DATA_FA_PSEUDO_ELEMENT) && (!node.parentNode || node.parentNode.tagName !== 'svg');
}
function $bf68c0e6076612b9$var$searchPseudoElements(root) {
    if (!$bf68c0e6076612b9$var$IS_DOM) return;
    return new Promise(function(resolve, reject) {
        var operations = $bf68c0e6076612b9$var$toArray(root.querySelectorAll('*')).filter($bf68c0e6076612b9$var$processable).map($bf68c0e6076612b9$var$replace);
        var end = $bf68c0e6076612b9$var$perf.begin('searchPseudoElements');
        $bf68c0e6076612b9$var$disableObservation();
        Promise.all(operations).then(function() {
            end();
            $bf68c0e6076612b9$var$enableObservation();
            resolve();
        }).catch(function() {
            end();
            $bf68c0e6076612b9$var$enableObservation();
            reject();
        });
    });
}
var $bf68c0e6076612b9$var$PseudoElements = {
    hooks: function hooks() {
        return {
            mutationObserverCallbacks: function mutationObserverCallbacks(accumulator) {
                accumulator.pseudoElementsCallback = $bf68c0e6076612b9$var$searchPseudoElements;
                return accumulator;
            }
        };
    },
    provides: function provides(providers$$1) {
        providers$$1.pseudoElements2svg = function(params) {
            var _params$node = params.node, node = _params$node === void 0 ? $bf68c0e6076612b9$var$DOCUMENT : _params$node;
            if ($bf68c0e6076612b9$var$config.searchPseudoElements) $bf68c0e6076612b9$var$searchPseudoElements(node);
        };
    }
};
var $bf68c0e6076612b9$var$_unwatched = false;
var $bf68c0e6076612b9$var$MutationObserver$1 = {
    mixout: function mixout() {
        return {
            dom: {
                unwatch: function unwatch() {
                    $bf68c0e6076612b9$var$disableObservation();
                    $bf68c0e6076612b9$var$_unwatched = true;
                }
            }
        };
    },
    hooks: function hooks() {
        return {
            bootstrap: function bootstrap() {
                $bf68c0e6076612b9$var$observe($bf68c0e6076612b9$var$chainHooks('mutationObserverCallbacks', {}));
            },
            noAuto: function noAuto() {
                $bf68c0e6076612b9$var$disconnect();
            },
            watch: function watch(params) {
                var observeMutationsRoot = params.observeMutationsRoot;
                if ($bf68c0e6076612b9$var$_unwatched) $bf68c0e6076612b9$var$enableObservation();
                else $bf68c0e6076612b9$var$observe($bf68c0e6076612b9$var$chainHooks('mutationObserverCallbacks', {
                    observeMutationsRoot: observeMutationsRoot
                }));
            }
        };
    }
};
var $bf68c0e6076612b9$var$parseTransformString = function parseTransformString(transformString) {
    var transform = {
        size: 16,
        x: 0,
        y: 0,
        flipX: false,
        flipY: false,
        rotate: 0
    };
    return transformString.toLowerCase().split(' ').reduce(function(acc, n) {
        var parts = n.toLowerCase().split('-');
        var first = parts[0];
        var rest = parts.slice(1).join('-');
        if (first && rest === 'h') {
            acc.flipX = true;
            return acc;
        }
        if (first && rest === 'v') {
            acc.flipY = true;
            return acc;
        }
        rest = parseFloat(rest);
        if (isNaN(rest)) return acc;
        switch(first){
            case 'grow':
                acc.size = acc.size + rest;
                break;
            case 'shrink':
                acc.size = acc.size - rest;
                break;
            case 'left':
                acc.x = acc.x - rest;
                break;
            case 'right':
                acc.x = acc.x + rest;
                break;
            case 'up':
                acc.y = acc.y - rest;
                break;
            case 'down':
                acc.y = acc.y + rest;
                break;
            case 'rotate':
                acc.rotate = acc.rotate + rest;
                break;
        }
        return acc;
    }, transform);
};
var $bf68c0e6076612b9$var$PowerTransforms = {
    mixout: function mixout() {
        return {
            parse: {
                transform: function transform(transformString) {
                    return $bf68c0e6076612b9$var$parseTransformString(transformString);
                }
            }
        };
    },
    hooks: function hooks() {
        return {
            parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
                var transformString = node.getAttribute('data-fa-transform');
                if (transformString) accumulator.transform = $bf68c0e6076612b9$var$parseTransformString(transformString);
                return accumulator;
            }
        };
    },
    provides: function provides(providers) {
        providers.generateAbstractTransformGrouping = function(_ref) {
            var main = _ref.main, transform = _ref.transform, containerWidth = _ref.containerWidth, iconWidth = _ref.iconWidth;
            var outer = {
                transform: "translate(".concat(containerWidth / 2, " 256)")
            };
            var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
            var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
            var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
            var inner = {
                transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
            };
            var path = {
                transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
            };
            var operations = {
                outer: outer,
                inner: inner,
                path: path
            };
            return {
                tag: 'g',
                attributes: $bf68c0e6076612b9$var$_objectSpread2({}, operations.outer),
                children: [
                    {
                        tag: 'g',
                        attributes: $bf68c0e6076612b9$var$_objectSpread2({}, operations.inner),
                        children: [
                            {
                                tag: main.icon.tag,
                                children: main.icon.children,
                                attributes: $bf68c0e6076612b9$var$_objectSpread2($bf68c0e6076612b9$var$_objectSpread2({}, main.icon.attributes), operations.path)
                            }
                        ]
                    }
                ]
            };
        };
    }
};
var $bf68c0e6076612b9$var$ALL_SPACE = {
    x: 0,
    y: 0,
    width: '100%',
    height: '100%'
};
function $bf68c0e6076612b9$var$fillBlack(abstract) {
    var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (abstract.attributes && (abstract.attributes.fill || force)) abstract.attributes.fill = 'black';
    return abstract;
}
function $bf68c0e6076612b9$var$deGroup(abstract) {
    if (abstract.tag === 'g') return abstract.children;
    else return [
        abstract
    ];
}
var $bf68c0e6076612b9$var$Masks = {
    hooks: function hooks() {
        return {
            parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
                var maskData = node.getAttribute('data-fa-mask');
                var mask = !maskData ? $bf68c0e6076612b9$var$emptyCanonicalIcon() : $bf68c0e6076612b9$var$getCanonicalIcon(maskData.split(' ').map(function(i) {
                    return i.trim();
                }));
                if (!mask.prefix) mask.prefix = $bf68c0e6076612b9$var$getDefaultUsablePrefix();
                accumulator.mask = mask;
                accumulator.maskId = node.getAttribute('data-fa-mask-id');
                return accumulator;
            }
        };
    },
    provides: function provides(providers) {
        providers.generateAbstractMask = function(_ref) {
            var children = _ref.children, attributes = _ref.attributes, main = _ref.main, mask = _ref.mask, explicitMaskId = _ref.maskId, transform = _ref.transform;
            var mainWidth = main.width, mainPath = main.icon;
            var maskWidth = mask.width, maskPath = mask.icon;
            var trans = $bf68c0e6076612b9$var$transformForSvg({
                transform: transform,
                containerWidth: maskWidth,
                iconWidth: mainWidth
            });
            var maskRect = {
                tag: 'rect',
                attributes: $bf68c0e6076612b9$var$_objectSpread2($bf68c0e6076612b9$var$_objectSpread2({}, $bf68c0e6076612b9$var$ALL_SPACE), {}, {
                    fill: 'white'
                })
            };
            var maskInnerGroupChildrenMixin = mainPath.children ? {
                children: mainPath.children.map($bf68c0e6076612b9$var$fillBlack)
            } : {};
            var maskInnerGroup = {
                tag: 'g',
                attributes: $bf68c0e6076612b9$var$_objectSpread2({}, trans.inner),
                children: [
                    $bf68c0e6076612b9$var$fillBlack($bf68c0e6076612b9$var$_objectSpread2({
                        tag: mainPath.tag,
                        attributes: $bf68c0e6076612b9$var$_objectSpread2($bf68c0e6076612b9$var$_objectSpread2({}, mainPath.attributes), trans.path)
                    }, maskInnerGroupChildrenMixin))
                ]
            };
            var maskOuterGroup = {
                tag: 'g',
                attributes: $bf68c0e6076612b9$var$_objectSpread2({}, trans.outer),
                children: [
                    maskInnerGroup
                ]
            };
            var maskId = "mask-".concat(explicitMaskId || $bf68c0e6076612b9$var$nextUniqueId());
            var clipId = "clip-".concat(explicitMaskId || $bf68c0e6076612b9$var$nextUniqueId());
            var maskTag = {
                tag: 'mask',
                attributes: $bf68c0e6076612b9$var$_objectSpread2($bf68c0e6076612b9$var$_objectSpread2({}, $bf68c0e6076612b9$var$ALL_SPACE), {}, {
                    id: maskId,
                    maskUnits: 'userSpaceOnUse',
                    maskContentUnits: 'userSpaceOnUse'
                }),
                children: [
                    maskRect,
                    maskOuterGroup
                ]
            };
            var defs = {
                tag: 'defs',
                children: [
                    {
                        tag: 'clipPath',
                        attributes: {
                            id: clipId
                        },
                        children: $bf68c0e6076612b9$var$deGroup(maskPath)
                    },
                    maskTag
                ]
            };
            children.push(defs, {
                tag: 'rect',
                attributes: $bf68c0e6076612b9$var$_objectSpread2({
                    fill: 'currentColor',
                    'clip-path': "url(#".concat(clipId, ")"),
                    mask: "url(#".concat(maskId, ")")
                }, $bf68c0e6076612b9$var$ALL_SPACE)
            });
            return {
                children: children,
                attributes: attributes
            };
        };
    }
};
var $bf68c0e6076612b9$var$MissingIconIndicator = {
    provides: function provides(providers) {
        var reduceMotion = false;
        if ($bf68c0e6076612b9$var$WINDOW.matchMedia) reduceMotion = $bf68c0e6076612b9$var$WINDOW.matchMedia('(prefers-reduced-motion: reduce)').matches;
        providers.missingIconAbstract = function() {
            var gChildren = [];
            var FILL = {
                fill: 'currentColor'
            };
            var ANIMATION_BASE = {
                attributeType: 'XML',
                repeatCount: 'indefinite',
                dur: '2s'
            }; // Ring
            gChildren.push({
                tag: 'path',
                attributes: $bf68c0e6076612b9$var$_objectSpread2($bf68c0e6076612b9$var$_objectSpread2({}, FILL), {}, {
                    d: 'M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z'
                })
            });
            var OPACITY_ANIMATE = $bf68c0e6076612b9$var$_objectSpread2($bf68c0e6076612b9$var$_objectSpread2({}, ANIMATION_BASE), {}, {
                attributeName: 'opacity'
            });
            var dot = {
                tag: 'circle',
                attributes: $bf68c0e6076612b9$var$_objectSpread2($bf68c0e6076612b9$var$_objectSpread2({}, FILL), {}, {
                    cx: '256',
                    cy: '364',
                    r: '28'
                }),
                children: []
            };
            if (!reduceMotion) dot.children.push({
                tag: 'animate',
                attributes: $bf68c0e6076612b9$var$_objectSpread2($bf68c0e6076612b9$var$_objectSpread2({}, ANIMATION_BASE), {}, {
                    attributeName: 'r',
                    values: '28;14;28;28;14;28;'
                })
            }, {
                tag: 'animate',
                attributes: $bf68c0e6076612b9$var$_objectSpread2($bf68c0e6076612b9$var$_objectSpread2({}, OPACITY_ANIMATE), {}, {
                    values: '1;0;1;1;0;1;'
                })
            });
            gChildren.push(dot);
            gChildren.push({
                tag: 'path',
                attributes: $bf68c0e6076612b9$var$_objectSpread2($bf68c0e6076612b9$var$_objectSpread2({}, FILL), {}, {
                    opacity: '1',
                    d: 'M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z'
                }),
                children: reduceMotion ? [] : [
                    {
                        tag: 'animate',
                        attributes: $bf68c0e6076612b9$var$_objectSpread2($bf68c0e6076612b9$var$_objectSpread2({}, OPACITY_ANIMATE), {}, {
                            values: '1;0;0;0;0;1;'
                        })
                    }
                ]
            });
            if (!reduceMotion) // Exclamation
            gChildren.push({
                tag: 'path',
                attributes: $bf68c0e6076612b9$var$_objectSpread2($bf68c0e6076612b9$var$_objectSpread2({}, FILL), {}, {
                    opacity: '0',
                    d: 'M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z'
                }),
                children: [
                    {
                        tag: 'animate',
                        attributes: $bf68c0e6076612b9$var$_objectSpread2($bf68c0e6076612b9$var$_objectSpread2({}, OPACITY_ANIMATE), {}, {
                            values: '0;0;1;1;0;0;'
                        })
                    }
                ]
            });
            return {
                tag: 'g',
                attributes: {
                    'class': 'missing'
                },
                children: gChildren
            };
        };
    }
};
var $bf68c0e6076612b9$var$SvgSymbols = {
    hooks: function hooks() {
        return {
            parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
                var symbolData = node.getAttribute('data-fa-symbol');
                var symbol = symbolData === null ? false : symbolData === '' ? true : symbolData;
                accumulator['symbol'] = symbol;
                return accumulator;
            }
        };
    }
};
var $bf68c0e6076612b9$var$plugins = [
    $bf68c0e6076612b9$var$InjectCSS,
    $bf68c0e6076612b9$var$ReplaceElements,
    $bf68c0e6076612b9$var$Layers,
    $bf68c0e6076612b9$var$LayersCounter,
    $bf68c0e6076612b9$var$LayersText,
    $bf68c0e6076612b9$var$PseudoElements,
    $bf68c0e6076612b9$var$MutationObserver$1,
    $bf68c0e6076612b9$var$PowerTransforms,
    $bf68c0e6076612b9$var$Masks,
    $bf68c0e6076612b9$var$MissingIconIndicator,
    $bf68c0e6076612b9$var$SvgSymbols
];
$bf68c0e6076612b9$var$registerPlugins($bf68c0e6076612b9$var$plugins, {
    mixoutsTo: $bf68c0e6076612b9$export$644d8ea042df96a6
});
var $bf68c0e6076612b9$export$4f8e844b2782642c = $bf68c0e6076612b9$export$644d8ea042df96a6.noAuto;
var $bf68c0e6076612b9$export$e506a1d27d1eaa20 = $bf68c0e6076612b9$export$644d8ea042df96a6.config;
var $bf68c0e6076612b9$export$b839f963c7dc0e34 = $bf68c0e6076612b9$export$644d8ea042df96a6.library;
var $bf68c0e6076612b9$export$df3a06d6289f983e = $bf68c0e6076612b9$export$644d8ea042df96a6.dom;
var $bf68c0e6076612b9$export$98e6a39c04603d36 = $bf68c0e6076612b9$export$644d8ea042df96a6.parse;
var $bf68c0e6076612b9$export$221fed4a47f597a5 = $bf68c0e6076612b9$export$644d8ea042df96a6.findIconDefinition;
var $bf68c0e6076612b9$export$a10125c086a4df16 = $bf68c0e6076612b9$export$644d8ea042df96a6.toHtml;
var $bf68c0e6076612b9$export$1ca1ec8b29a4ce27 = $bf68c0e6076612b9$export$644d8ea042df96a6.icon;
var $bf68c0e6076612b9$export$50a222d9023da98b = $bf68c0e6076612b9$export$644d8ea042df96a6.layer;
var $bf68c0e6076612b9$export$6f093cfa640b7166 = $bf68c0e6076612b9$export$644d8ea042df96a6.text;
var $bf68c0e6076612b9$export$e575061ef2a070eb = $bf68c0e6076612b9$export$644d8ea042df96a6.counter;


var $fc5946c012728308$exports = {};
'use strict';
Object.defineProperty($fc5946c012728308$exports, '__esModule', {
    value: true
});
var $fc5946c012728308$var$prefix = 'fal';
var $fc5946c012728308$var$iconName = 'building';
var $fc5946c012728308$var$width = 448;
var $fc5946c012728308$var$height = 512;
var $fc5946c012728308$var$ligatures = [];
var $fc5946c012728308$var$unicode = 'f1ad';
var $fc5946c012728308$var$svgPathData = 'M192 107v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12zm116-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm-128 96h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm128 0h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm-128 96h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm128 0h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm140 205v20H0v-20c0-6.627 5.373-12 12-12h20V24C32 10.745 42.745 0 56 0h336c13.255 0 24 10.745 24 24v456h20c6.627 0 12 5.373 12 12zm-64-12V32H64v448h128v-85c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v85h128z';
$fc5946c012728308$exports.definition = {
    prefix: $fc5946c012728308$var$prefix,
    iconName: $fc5946c012728308$var$iconName,
    icon: [
        $fc5946c012728308$var$width,
        $fc5946c012728308$var$height,
        $fc5946c012728308$var$ligatures,
        $fc5946c012728308$var$unicode,
        $fc5946c012728308$var$svgPathData
    ]
};
$fc5946c012728308$exports.faBuilding = $fc5946c012728308$exports.definition;
$fc5946c012728308$exports.prefix = $fc5946c012728308$var$prefix;
$fc5946c012728308$exports.iconName = $fc5946c012728308$var$iconName;
$fc5946c012728308$exports.width = $fc5946c012728308$var$width;
$fc5946c012728308$exports.height = $fc5946c012728308$var$height;
$fc5946c012728308$exports.ligatures = $fc5946c012728308$var$ligatures;
$fc5946c012728308$exports.unicode = $fc5946c012728308$var$unicode;
$fc5946c012728308$exports.svgPathData = $fc5946c012728308$var$svgPathData;


var $d6a9e5c5f76bd73a$exports = {};
'use strict';
Object.defineProperty($d6a9e5c5f76bd73a$exports, '__esModule', {
    value: true
});
var $d6a9e5c5f76bd73a$var$prefix = 'fal';
var $d6a9e5c5f76bd73a$var$iconName = 'envelope';
var $d6a9e5c5f76bd73a$var$width = 512;
var $d6a9e5c5f76bd73a$var$height = 512;
var $d6a9e5c5f76bd73a$var$ligatures = [];
var $d6a9e5c5f76bd73a$var$unicode = 'f0e0';
var $d6a9e5c5f76bd73a$var$svgPathData = 'M464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM48 96h416c8.8 0 16 7.2 16 16v41.4c-21.9 18.5-53.2 44-150.6 121.3-16.9 13.4-50.2 45.7-73.4 45.3-23.2.4-56.6-31.9-73.4-45.3C85.2 197.4 53.9 171.9 32 153.4V112c0-8.8 7.2-16 16-16zm416 320H48c-8.8 0-16-7.2-16-16V195c22.8 18.7 58.8 47.6 130.7 104.7 20.5 16.4 56.7 52.5 93.3 52.3 36.4.3 72.3-35.5 93.3-52.3 71.9-57.1 107.9-86 130.7-104.7v205c0 8.8-7.2 16-16 16z';
$d6a9e5c5f76bd73a$exports.definition = {
    prefix: $d6a9e5c5f76bd73a$var$prefix,
    iconName: $d6a9e5c5f76bd73a$var$iconName,
    icon: [
        $d6a9e5c5f76bd73a$var$width,
        $d6a9e5c5f76bd73a$var$height,
        $d6a9e5c5f76bd73a$var$ligatures,
        $d6a9e5c5f76bd73a$var$unicode,
        $d6a9e5c5f76bd73a$var$svgPathData
    ]
};
$d6a9e5c5f76bd73a$exports.faEnvelope = $d6a9e5c5f76bd73a$exports.definition;
$d6a9e5c5f76bd73a$exports.prefix = $d6a9e5c5f76bd73a$var$prefix;
$d6a9e5c5f76bd73a$exports.iconName = $d6a9e5c5f76bd73a$var$iconName;
$d6a9e5c5f76bd73a$exports.width = $d6a9e5c5f76bd73a$var$width;
$d6a9e5c5f76bd73a$exports.height = $d6a9e5c5f76bd73a$var$height;
$d6a9e5c5f76bd73a$exports.ligatures = $d6a9e5c5f76bd73a$var$ligatures;
$d6a9e5c5f76bd73a$exports.unicode = $d6a9e5c5f76bd73a$var$unicode;
$d6a9e5c5f76bd73a$exports.svgPathData = $d6a9e5c5f76bd73a$var$svgPathData;


var $438271b899ed0840$exports = {};
'use strict';
Object.defineProperty($438271b899ed0840$exports, '__esModule', {
    value: true
});
var $438271b899ed0840$var$prefix = 'fal';
var $438271b899ed0840$var$iconName = 'key';
var $438271b899ed0840$var$width = 512;
var $438271b899ed0840$var$height = 512;
var $438271b899ed0840$var$ligatures = [];
var $438271b899ed0840$var$unicode = 'f084';
var $438271b899ed0840$var$svgPathData = 'M336 32c79.529 0 144 64.471 144 144s-64.471 144-144 144c-18.968 0-37.076-3.675-53.661-10.339L240 352h-48v64h-64v64H32v-80l170.339-170.339C195.675 213.076 192 194.968 192 176c0-79.529 64.471-144 144-144m0-32c-97.184 0-176 78.769-176 176 0 15.307 1.945 30.352 5.798 44.947L7.029 379.716A24.003 24.003 0 0 0 0 396.686V488c0 13.255 10.745 24 24 24h112c13.255 0 24-10.745 24-24v-40h40c13.255 0 24-10.745 24-24v-40h19.314c6.365 0 12.47-2.529 16.971-7.029l30.769-30.769C305.648 350.055 320.693 352 336 352c97.184 0 176-78.769 176-176C512 78.816 433.231 0 336 0zm48 108c11.028 0 20 8.972 20 20s-8.972 20-20 20-20-8.972-20-20 8.972-20 20-20m0-28c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48z';
$438271b899ed0840$exports.definition = {
    prefix: $438271b899ed0840$var$prefix,
    iconName: $438271b899ed0840$var$iconName,
    icon: [
        $438271b899ed0840$var$width,
        $438271b899ed0840$var$height,
        $438271b899ed0840$var$ligatures,
        $438271b899ed0840$var$unicode,
        $438271b899ed0840$var$svgPathData
    ]
};
$438271b899ed0840$exports.faKey = $438271b899ed0840$exports.definition;
$438271b899ed0840$exports.prefix = $438271b899ed0840$var$prefix;
$438271b899ed0840$exports.iconName = $438271b899ed0840$var$iconName;
$438271b899ed0840$exports.width = $438271b899ed0840$var$width;
$438271b899ed0840$exports.height = $438271b899ed0840$var$height;
$438271b899ed0840$exports.ligatures = $438271b899ed0840$var$ligatures;
$438271b899ed0840$exports.unicode = $438271b899ed0840$var$unicode;
$438271b899ed0840$exports.svgPathData = $438271b899ed0840$var$svgPathData;


var $3e1fbd6e7ac8c2a5$exports = {};
'use strict';
Object.defineProperty($3e1fbd6e7ac8c2a5$exports, '__esModule', {
    value: true
});
var $3e1fbd6e7ac8c2a5$var$prefix = 'fal';
var $3e1fbd6e7ac8c2a5$var$iconName = 'map-marker';
var $3e1fbd6e7ac8c2a5$var$width = 384;
var $3e1fbd6e7ac8c2a5$var$height = 512;
var $3e1fbd6e7ac8c2a5$var$ligatures = [];
var $3e1fbd6e7ac8c2a5$var$unicode = 'f041';
var $3e1fbd6e7ac8c2a5$var$svgPathData = 'M192 0C85.961 0 0 85.961 0 192c0 77.413 26.97 99.031 172.268 309.67 9.534 13.772 29.929 13.774 39.465 0C357.03 291.031 384 269.413 384 192 384 85.961 298.039 0 192 0zm0 473.931C52.705 272.488 32 256.494 32 192c0-42.738 16.643-82.917 46.863-113.137S149.262 32 192 32s82.917 16.643 113.137 46.863S352 149.262 352 192c0 64.49-20.692 80.47-160 281.931z';
$3e1fbd6e7ac8c2a5$exports.definition = {
    prefix: $3e1fbd6e7ac8c2a5$var$prefix,
    iconName: $3e1fbd6e7ac8c2a5$var$iconName,
    icon: [
        $3e1fbd6e7ac8c2a5$var$width,
        $3e1fbd6e7ac8c2a5$var$height,
        $3e1fbd6e7ac8c2a5$var$ligatures,
        $3e1fbd6e7ac8c2a5$var$unicode,
        $3e1fbd6e7ac8c2a5$var$svgPathData
    ]
};
$3e1fbd6e7ac8c2a5$exports.faMapMarker = $3e1fbd6e7ac8c2a5$exports.definition;
$3e1fbd6e7ac8c2a5$exports.prefix = $3e1fbd6e7ac8c2a5$var$prefix;
$3e1fbd6e7ac8c2a5$exports.iconName = $3e1fbd6e7ac8c2a5$var$iconName;
$3e1fbd6e7ac8c2a5$exports.width = $3e1fbd6e7ac8c2a5$var$width;
$3e1fbd6e7ac8c2a5$exports.height = $3e1fbd6e7ac8c2a5$var$height;
$3e1fbd6e7ac8c2a5$exports.ligatures = $3e1fbd6e7ac8c2a5$var$ligatures;
$3e1fbd6e7ac8c2a5$exports.unicode = $3e1fbd6e7ac8c2a5$var$unicode;
$3e1fbd6e7ac8c2a5$exports.svgPathData = $3e1fbd6e7ac8c2a5$var$svgPathData;


var $324e803c791fbfca$exports = {};
'use strict';
Object.defineProperty($324e803c791fbfca$exports, '__esModule', {
    value: true
});
var $324e803c791fbfca$var$prefix = 'fal';
var $324e803c791fbfca$var$iconName = 'times';
var $324e803c791fbfca$var$width = 320;
var $324e803c791fbfca$var$height = 512;
var $324e803c791fbfca$var$ligatures = [];
var $324e803c791fbfca$var$unicode = 'f00d';
var $324e803c791fbfca$var$svgPathData = 'M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z';
$324e803c791fbfca$exports.definition = {
    prefix: $324e803c791fbfca$var$prefix,
    iconName: $324e803c791fbfca$var$iconName,
    icon: [
        $324e803c791fbfca$var$width,
        $324e803c791fbfca$var$height,
        $324e803c791fbfca$var$ligatures,
        $324e803c791fbfca$var$unicode,
        $324e803c791fbfca$var$svgPathData
    ]
};
$324e803c791fbfca$exports.faTimes = $324e803c791fbfca$exports.definition;
$324e803c791fbfca$exports.prefix = $324e803c791fbfca$var$prefix;
$324e803c791fbfca$exports.iconName = $324e803c791fbfca$var$iconName;
$324e803c791fbfca$exports.width = $324e803c791fbfca$var$width;
$324e803c791fbfca$exports.height = $324e803c791fbfca$var$height;
$324e803c791fbfca$exports.ligatures = $324e803c791fbfca$var$ligatures;
$324e803c791fbfca$exports.unicode = $324e803c791fbfca$var$unicode;
$324e803c791fbfca$exports.svgPathData = $324e803c791fbfca$var$svgPathData;


var $c654ed24735d6c34$exports = {};
'use strict';
Object.defineProperty($c654ed24735d6c34$exports, '__esModule', {
    value: true
});
var $c654ed24735d6c34$var$prefix = 'fab';
var $c654ed24735d6c34$var$iconName = 'github';
var $c654ed24735d6c34$var$width = 496;
var $c654ed24735d6c34$var$height = 512;
var $c654ed24735d6c34$var$ligatures = [];
var $c654ed24735d6c34$var$unicode = 'f09b';
var $c654ed24735d6c34$var$svgPathData = 'M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z';
$c654ed24735d6c34$exports.definition = {
    prefix: $c654ed24735d6c34$var$prefix,
    iconName: $c654ed24735d6c34$var$iconName,
    icon: [
        $c654ed24735d6c34$var$width,
        $c654ed24735d6c34$var$height,
        $c654ed24735d6c34$var$ligatures,
        $c654ed24735d6c34$var$unicode,
        $c654ed24735d6c34$var$svgPathData
    ]
};
$c654ed24735d6c34$exports.faGithub = $c654ed24735d6c34$exports.definition;
$c654ed24735d6c34$exports.prefix = $c654ed24735d6c34$var$prefix;
$c654ed24735d6c34$exports.iconName = $c654ed24735d6c34$var$iconName;
$c654ed24735d6c34$exports.width = $c654ed24735d6c34$var$width;
$c654ed24735d6c34$exports.height = $c654ed24735d6c34$var$height;
$c654ed24735d6c34$exports.ligatures = $c654ed24735d6c34$var$ligatures;
$c654ed24735d6c34$exports.unicode = $c654ed24735d6c34$var$unicode;
$c654ed24735d6c34$exports.svgPathData = $c654ed24735d6c34$var$svgPathData;


var $8fbc20b3b0fd59e7$exports = {};
'use strict';
Object.defineProperty($8fbc20b3b0fd59e7$exports, '__esModule', {
    value: true
});
var $8fbc20b3b0fd59e7$var$prefix = 'fab';
var $8fbc20b3b0fd59e7$var$iconName = 'linkedin';
var $8fbc20b3b0fd59e7$var$width = 448;
var $8fbc20b3b0fd59e7$var$height = 512;
var $8fbc20b3b0fd59e7$var$ligatures = [];
var $8fbc20b3b0fd59e7$var$unicode = 'f08c';
var $8fbc20b3b0fd59e7$var$svgPathData = 'M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z';
$8fbc20b3b0fd59e7$exports.definition = {
    prefix: $8fbc20b3b0fd59e7$var$prefix,
    iconName: $8fbc20b3b0fd59e7$var$iconName,
    icon: [
        $8fbc20b3b0fd59e7$var$width,
        $8fbc20b3b0fd59e7$var$height,
        $8fbc20b3b0fd59e7$var$ligatures,
        $8fbc20b3b0fd59e7$var$unicode,
        $8fbc20b3b0fd59e7$var$svgPathData
    ]
};
$8fbc20b3b0fd59e7$exports.faLinkedin = $8fbc20b3b0fd59e7$exports.definition;
$8fbc20b3b0fd59e7$exports.prefix = $8fbc20b3b0fd59e7$var$prefix;
$8fbc20b3b0fd59e7$exports.iconName = $8fbc20b3b0fd59e7$var$iconName;
$8fbc20b3b0fd59e7$exports.width = $8fbc20b3b0fd59e7$var$width;
$8fbc20b3b0fd59e7$exports.height = $8fbc20b3b0fd59e7$var$height;
$8fbc20b3b0fd59e7$exports.ligatures = $8fbc20b3b0fd59e7$var$ligatures;
$8fbc20b3b0fd59e7$exports.unicode = $8fbc20b3b0fd59e7$var$unicode;
$8fbc20b3b0fd59e7$exports.svgPathData = $8fbc20b3b0fd59e7$var$svgPathData;


var $91f387bb5b843060$var$WAIT_WHEN_COMPLETE = 1500;
var $91f387bb5b843060$var$WAIT_WHEN_EMPTY = 750;
var $91f387bb5b843060$var$TYPE_FREQUENCY = 120;
var $91f387bb5b843060$var$CURSOR_BLINK_FREQUENCY = 400;
(0, $bf68c0e6076612b9$export$b839f963c7dc0e34).add((0, $fc5946c012728308$exports.faBuilding), (0, $d6a9e5c5f76bd73a$exports.faEnvelope), (0, $c654ed24735d6c34$exports.faGithub), (0, $438271b899ed0840$exports.faKey), (0, $8fbc20b3b0fd59e7$exports.faLinkedin), (0, $3e1fbd6e7ac8c2a5$exports.faMapMarker), (0, $324e803c791fbfca$exports.faTimes));
(0, $bf68c0e6076612b9$export$df3a06d6289f983e).watch();
var $91f387bb5b843060$var$ROLE_SUFFIXES = /\b(Developer|Expert|Engineer|Pro|Architect|Enthusiast|Alumnus)\s*$/i;
var $91f387bb5b843060$var$getRole = function(word) {
    var match = word.trim().match($91f387bb5b843060$var$ROLE_SUFFIXES);
    return match ? match[1].toLowerCase() : null;
};
var $91f387bb5b843060$var$shuffle = function(a) {
    for(var i = a.length - 1; i > 0; i--){
        var j = Math.floor(Math.random() * (i + 1));
        var ref;
        ref = [
            a[j],
            a[i]
        ], a[i] = ref[0], a[j] = ref[1], ref;
    }
    // Reshuffle until no two adjacent entries share a role suffix
    for(var i1 = 1; i1 < a.length; i1++){
        var prev = $91f387bb5b843060$var$getRole(a[i1 - 1]);
        var curr = $91f387bb5b843060$var$getRole(a[i1]);
        if (prev && curr && prev === curr) // Find a non-conflicting swap candidate further ahead
        for(var j1 = i1 + 1; j1 < a.length; j1++){
            var candidate = $91f387bb5b843060$var$getRole(a[j1]);
            if (candidate !== prev && (i1 + 1 >= a.length || candidate !== $91f387bb5b843060$var$getRole(a[i1 + 1]))) {
                var ref1;
                ref1 = [
                    a[j1],
                    a[i1]
                ], a[i1] = ref1[0], a[j1] = ref1[1], ref1;
                break;
            }
        }
    }
    return a;
};
var $91f387bb5b843060$var$$ = function $(query) {
    var res = document.querySelectorAll(query);
    return res.length > 1 ? res : res[0];
};
window.onload = function() {
    var $hiddenClassName = "hidden";
    var $mainContainer = $91f387bb5b843060$var$$("#main-container");
    var $privacyContainer = $91f387bb5b843060$var$$("#privacy-container");
    var $cursor = $91f387bb5b843060$var$$("#cursor");
    var $textRotation = $91f387bb5b843060$var$$("#textrotation");
    var colors = [
        "#000"
    ];
    var words = $textRotation.innerHTML.replace(/\s{4}/g, "").split(",");
    $91f387bb5b843060$var$shuffle(words);
    $textRotation.innerHTML = "";
    var letterCount = 1;
    var waiting = false;
    var isRemoving = false;
    $textRotation.setAttribute("style", "color:" + colors[0]);
    setInterval(function() {
        if (waiting) return;
        if (letterCount < 0 && isRemoving) {
            waiting = true;
            // Select new Word
            setTimeout(function() {
                var usedColor = colors.shift();
                colors.push(usedColor);
                var usedWord = words.shift();
                words.push(usedWord);
                $textRotation.setAttribute("style", "color:" + colors[0]);
                isRemoving = false;
                waiting = false;
            }, $91f387bb5b843060$var$WAIT_WHEN_EMPTY);
        } else if (letterCount === words[0].length + 1 && !isRemoving) {
            waiting = true;
            // Start Removing
            setTimeout(function() {
                isRemoving = true;
                waiting = false;
            }, $91f387bb5b843060$var$WAIT_WHEN_COMPLETE);
        } else {
            $textRotation.innerHTML = words[0].substring(0, letterCount);
            letterCount += isRemoving ? -1 : 1;
        }
    }, $91f387bb5b843060$var$TYPE_FREQUENCY);
    // Underscore Rendering
    setInterval(function() {
        $cursor.classList.toggle("visually-hidden");
    }, $91f387bb5b843060$var$CURSOR_BLINK_FREQUENCY);
    $91f387bb5b843060$var$$("#privacy-button").addEventListener("click", function() {
        $mainContainer.classList.add($hiddenClassName);
        $privacyContainer.classList.remove($hiddenClassName);
    });
    $91f387bb5b843060$var$$("#privacy-back-button").addEventListener("click", function() {
        $mainContainer.classList.remove($hiddenClassName);
        $privacyContainer.classList.add($hiddenClassName);
    });
};

})();
//# sourceMappingURL=app.e14939ef.js.map
